import { PlanService } from './inc/plan.js'
// import Plan3D from './inc/plan-3d.js'
// import Plan2D from './inc/plan-2d.js'

if (window.location.search.indexOf('nojs') !== -1){
	variable = 'fata error'; // Purposely trigger fatal error
}

var customizer;

// Sanitize value decimal (see: https://stackoverflow.com/questions/10473994/javascript-adding-decimal-numbers-issue)
Number.prototype.sanitize = function(decimal = 12){
	return +(this).toFixed(decimal);
}

Number.prototype.toLocale = function(){
	return new Intl.NumberFormat(customizer.settings.locale).format(this);
}

Number.prototype.format = function(){
	// Mimic php's number_format (https://stackoverflow.com/questions/12820312/what-is-the-js-equivalent-to-the-php-function-number-format)
	const number = (this + '').replace(/[^0-9+\-Ee.]/g, '');
	const decimals = !isFinite(+customizer.settings.decimals_count) ? 0 : Math.abs(customizer.settings.decimals_count);

	var n = !isFinite(+number) ? 0 : +number,
		s = '',
		toFixedFix = function (n, decimals) {
			var k = Math.pow(10, decimals);
			return '' + Math.round(n * k) / k;
		};

	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (decimals ? toFixedFix(n, decimals) : '' + Math.round(n)).split('.');

	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, customizer.settings.thousand_separator);
	}
	
	if ((s[1] || '').length < decimals) {
		s[1] = s[1] || '';
		s[1] += new Array(decimals - s[1].length + 1).join('0');
	}

	// Trim decimals
	if (customizer.settings.trim_zeros && decimals > 0 && parseInt(s[s.length - 1]) === 0){
		return s[0];
	}

	return s.join(customizer.settings.decimal_separator);
}

Number.prototype.toPrice = function(){
	return customizer.settings.price_format.replace('%1$s', customizer.settings.currency_symbol).replace('%2$s', this.format());

	/* JS price formatting mimic php (WC) number formating. We might need to go back to Intl.NumberFormat using locale if/when the formating and currency will be decided by end user
	return new Intl.NumberFormat(customizer.settings.locale, {
		style: 'decimal',
		prefix: '',
		suffix: '',
		minimumFractionDigits: this % 1 === 0 ? 0 : 2, // Show decimals only when necesary
		maximumFractionDigits: this % 1 === 0 ? 0 : 2, // Show decimals only when necesary
		style: 'currency',
		useGrouping: 'always', // Force es-ES to group 4 number digit
		currency: customizer.settings.currency,
	}).format(this);
	*/
}

Number.prototype.toArea = function(){
	return this.format() + ' ' + customizer.settings.area_symbol;
	/*
	return new Intl.NumberFormat(customizer.settings.locale, {
		style: 'decimal',
		prefix: '',
		suffix: '²',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
		style: 'unit',
		unit: customizer.settings.area,
	}).format(this);
	*/
}

String.prototype.translate = function(){
	console.warn('Dev: Legacy translation for: ' + str);è
	return this;
}

function _cmz(str){
	return CMZ.i18n.hasOwnProperty(str) ? CMZ.i18n[str] : str;
}

class Customizer{
	constructor(){
		customizer = this;

		this.settings = CMZ.settings;
		this.content  = CMZ.content;
		this.property = CMZ.property;
		this.totals = CMZ.totals;

		this.map = {};

		this.breakdown = [];

		this.session = new Session();
		this.storyline = new Storyline();
		this.spot = new Spot();
		this.steps = new Steps();
		this.billing = new Billing();
		this.prices = new Prices();
		this.summary = new Summary();

		this.spot.init();
		this.steps.init();
		this.totals = this.getTotals();
		this.billing.init();
		// this.breakdown = this.getBreakdown();
		this.prices.init();
		this.summary.init();
		this.storyline.init();

		// Update on change
		document.addEventListener('cmzChoiceChanged', this.update.bind(this));
		this.update();
	}

	getTotals(){
		let prices = {};
		
		// Reset all values
		for (const key in this.totals){
			prices[key] = 0;
		}

		// Add fixed values (@todo dynamic values)
		prices.fees = this.billing.getFees();
		prices.prebook = CMZ.totals.prebook;

		// Spot
		prices.product = this.spot.getPrice();

		// Steps
		this.steps.forEach(step => {
			prices.options += step.getTotal();
		});

		prices.cart = prices.product + prices.options;
		prices.total = prices.cart + prices.fees;

		// Only keep two digits
		for (const key in prices){
			prices[key] = prices[key].sanitize(2);
		}

		return prices;
	}

	/*getBreakdown(){
		// Breakdowns are stored in simple object to be easy to find with key but might need a proper Breakdown class with map binding item id with index in future
		let items = {};

		// Spot
		// if (customizer.spot.hasChosen()){
			// items.push({
			items['spot'] = {
				id: 'spot',
				name: _cmz('Vivienda'),
				value: customizer.spot.getName(),
				price: customizer.spot.getPrice(),
				visible: customizer.spot.hasChosen()
			};
			// });
		// }

		// Steps
		customizer.steps.forEach(step => {
			// if (step.hasChosen() && !step.isFree()){
				if (step.type == 'multibool' || step.type == 'checkbox'){
					step.options.forEach(option => {
						// if (option.chosen){
							// items.push({
							items[option.id] = {
								id: option.id,
								name: option.name,
								value: _cmz('Sí'),
								price: option.price,
								visible: option.chosen && option.price
							}
							// });
						// }
					});

					return;
				}
			
				// items.push({
				items[step.id] = {
					id: step.id,
					name: step.name,
					value: step.getDisplayValue(),
					price: step.getTotal(),
					visible: step.hasChosen() && !step.isFree()
				};
				// });
			// }
		});

		// Fees
		// ...

		// Totals
		// items.push({
		items['total'] = {
			id: 'total',
			name: 'Total', // customizer.content['summary_breakdown_total_title'], // _cmz('Total'),
			value: '', // customizer.content['summary_breakdown_total_description'], // _cmz('Sin impuestos y tasas'),
			price: customizer.totals.total,
			visible: true
		};
		// });

		return items;
	}*/

	getItem(id){
		return this.map.hasOwnProperty(id) ? this.map[id] : false;
	}

	update(){
		console.log('Update');
		// Update spot
		// Spot update itself before fireing cmzChoiceChanged

		// Update steps
		this.steps.update();

		// Update static items (before totals get computed)
		this.billing.update();

		// Update totals
		this.totals = this.getTotals();

		// Update breakdown
		// this.breakdown = this.getBreakdown();

		// Update dynamic itmes (after totals get computed)
		this.billing.updatePlaceholders();

		// Update prices
		this.prices.update();

		// Update summary
		this.summary.update();

		// Update storyline
		this.storyline.update();

		// Update session
		this.session.update();
	}
}

// Session
class Session{
	constructor(){
		this.data = {};
		this.url = new URLSearchParams(window.location.search);
		this.saved = true;
		this.previous = '';

		// Retrieve data from cookie
		// if (document.cookie.indexOf('cmz-property-' + customizer.property) !== -1){
			// this.data = this.decode(document.cookie.split('cmz-property-' + customizer.property + '=').pop().split(';').shift());
		// }

		// Retrieve data from account
		if (CMZ.session){
			this.data = CMZ.session;
			// console.log('Session from server', this.data.spot);
		}

		// Retrieve from cookies? (Unlogged user could have a session stored in cookies) 
		// ...

		// Retrieve data from url
		if (this.url.has('data')){
			this.data = this.decode(this.url.get('data'));
			// console.log('Session from URL', this.data);
		}

		// Empty steps if no product
		if (!this.data?.product){
			this.data.product = '';
			this.data.steps = {};
		}

		if (this.data != CMZ.session){
			this.saved = false;
		}

		// Save session for difference check
		this.previous = this.encode(this.data);

		// Fill forms (not needed if PHP properly done)
		// Spot
		/*
		if (this.data?.spot){
			for (const k in this.data.spot){
				if (k == 'filters'){
					for (const filterId in this.data.spot[k]){
						const filter = CMZ.filters.find(filter => filter.id == filterId);
						
						if (filter){
							// Range
							switch (filter.type){
								case 'range': 
									['min', 'max'].forEach(minOrMax => {
										const input = document.querySelector(`.cmz-spot-display-option[name="cmz[spot][filters][${filterId}][${minOrMax}]"]`);
										
										if (input){
											input.value = this.data.spot[k][filterId][minOrMax];
											// console.log( 'input value set to', input.value, input );
										}
									});
								break;

								case 'radio': 
									const input = document.querySelector(`.cmz-spot-display-option[name="cmz[spot][filters][${filterId}]"][value="${this.data.spot[k][filterId]}"]`);
										
									if (input){
										input.checked = true;
										// input.checked = !!input.value == this.data.spot[k][filterId];
										// console.log( 'input checked set to', input.checked, input );
									}

								break;
							}
						}
					}

					continue;
				}

				const input = document.getElementById(`cmz-spot-${k}-input-${this.data.spot[k]}`);

				if (input){
					input.checked = true;
				}

			}
		}

		// Product
		if (this.data?.product){
			const product = document.querySelector('#cmz-spot-product-input-' + this.data.product).checked = true;
			
			if (product){
				product.checked = true;
			}
		}

		// Steps
		if (this.data?.steps){
			for (const k in this.data.steps){
			// this.data.steps.forEach(chosen => {
				// if (chosen){ // quick fix to prevent step without value from trigger error. Ideally, unchosen steps should not be added to the session data (@todo)
					this.data.steps[k].forEach((id, index) => {
						const input = document.querySelector('#cmz-option-input-' + id);
						input.checked = true;
						input.setAttribute('data-order', index); // Set order for ol options (not very clean but working)
					});
				// }
			// })
			}
		}
		*/

		// Save session in DB when close (https://www.igvita.com/2015/11/20/dont-lose-user-and-app-state-use-page-visibility/)
		// Does not work properly whenpage reloaded (not enough time for saving?)
		window.addEventListener('visibilitychange', () => {
			if (document.visibilityState == 'hidden' && !this.saved){
				this.save();
			}
		})

		// Cleanup URL
		const previous = this.url.toString();

		['reset', 'no-session-disclaimer'].forEach(key => {
			this.url.delete(key);	
		});

		const current = this.url.toString();

		if (current != previous){
			window.history.replaceState(null, '', window.location.origin + window.location.pathname + this.prefix(current));
		}
	}

	decode(data){
		return JSON.parse(atob(data));
	}

	encode(data){
		return Object.keys(this.data).length ? btoa(JSON.stringify(data)) : '';
	}

	update(){
		this.data = {
			version: CMZ.version,
			spot: {},
			product: '',
			steps: {}
		}

		// Spot
		this.data.spot = customizer.spot.display.settings;

		// Product
		if (customizer.spot.hasChosen()){
			this.data.product = customizer.spot.chosen.id;
		}

		// Steps
		customizer.steps.forEach(step => {
			if (step.hasChosen()){
				this.data.steps[step.id] = [];

				step.chosen.forEach(option => {
					this.data.steps[step.id].push(option.id);
				});
			}
		});

		// Convert to base64
		// const hash = this.data.product ? this.encode(this.data) : ''; // Why product needed to be set to save session?
		const hash = this.encode(this.data);

		// Bail early if no different (first page load)
		if (hash === this.previous){
			return;
		}

		console.log(this.data);

		// Reset saved status
		this.saved = false;

		// Replace previous
		this.previous = hash;

		// Create url parameter
		this.url.set('data', hash);

		// Replace history
		window.history.replaceState(null, '', window.location.origin + window.location.pathname + this.prefix(this.url.toString()));

		// Forge cookie
		// const date = new Date(new Date().getTime() + (31 * 24 * 60 * 60 * 1000)).toGMTString(); // 31 days
		// document.cookie = 'cmz-property-' + customizer.property + '=' + hash + '; expires=' + date + '; path=/'; // Might want to add 'Secure' on prod (https)
	}

	prefix(params){
		return params ? '?' + params : params;
	}

	save(){
		if (!CMZ.user.loggedin){
			return;
		}

		// console.log('Saving...', this.data);

		fetch(window.origin + '/wp-json/cmz/v1/session/save', {
			method: 'post',
			credentials: 'same-origin',
			body: JSON.stringify({
				property: customizer.property,
				session: this.data
			}),
			headers: new Headers({
				'Content-Type': 'application/json',
				'X-WP-Nonce': CMZ.nonce
			}),
		}).then(response => {return response.json()}).then(response => {
			console.log('Saved: ', response.success, response);

			if (!response.success){
				this.saved = false;
			}
		});

		this.saved = true;
	}
}

// Billing
class Billing{
	constructor(){
		this.items = {
			items : [],
			map: {},
			get: function (id) {
				return this.items[this.map[id]]
			},
			set: function (id, data = {}) {
				const item = this.get(id);

				if (item){
					item.set(data);
				}
			},
			has: function (id) {
				return this.map.hasOwnProperty(id)
			},
			add: function (item) {
				if (!this.has(item.id)){
					this.items.push(item);
					this.map[item.id] = this.items.length - 1;
				}
			}
		};

		// {item id} => computed value
		this.placeholders = {};

	}

	init(){
		// this.placeholders = customizer.totals;
		this.placeholders = {...customizer.totals}; // Not tested but fixed issue on cmz v1

		CMZ.billing.forEach(section => {
			section.items.forEach(_item => {
				// Create item
				const item = new BillingItem(_item);

				// Register item
				this.items.add(item);
				
				// Register placeholders
				if (_item.placeholderable && !this.placeholders.hasOwnProperty(item.id)){
					this.placeholders[item.id] = item.computedValue;
				}
			});
		});
	}

	updatePlaceholder(id, value){
		if (this.placeholders.hasOwnProperty(id)){
			this.placeholders[id] = value;
		}
	}

	getItems(){
		return this.items.items;
	}

	getFees(){
		let fees = 0;

		this.getItems().forEach(item => {
			if (item.is_fee && item.fulfilled && item.type == 'static'){ // only work with static items, for now
				fees += item.value;
			}
		});

		return fees;
	}

	update(){
		// Update totals placeholders
		/*
		for (const k in customizer.totals){
			this.updatePlaceholder(k, customizer.totals[k]);
		}
		*/

		// Spot
		const item = this.items.get('spot');

		if (item){
			item.set({
				description: customizer.spot.getName(),
				value: customizer.spot.getPrice(),
				visible: customizer.spot.hasChosen(),
				updateCallback: () => { // fired at the end of item.update()
					item.visible = item.visible && customizer.spot.hasChosen();
				}
			});
		}

		// Steps
		customizer.steps.forEach(step => {
			if (step.type == 'multibool' || step.type == 'checkbox'){ // @todo need to check if checkbox - might have been broken since conditional billing items
				step.options.forEach(option => {
					const item = this.items.get(option.id);

					if (item){
						item.set({
							description: _cmz('Sí'),
							value: option.price,
							visible: !!(option.chosen && option.price),  // Mis condition checks? - add step.isFullfilled()?
							updateCallback: () => { // fired at the end of item.update()
								item.visible = item.visible && !!(option.chosen && option.price);
							}
						});
					}
				});

				return;
			}

			const item = this.items.get(step.id);

			if (item){
				item.set({
					description: step.getDisplayValue(),
					value: step.getTotal(),
					visible: step.hasChosen(), // Mis condition checks? - add step.isFullfilled()?
					updateCallback: () => { // fired at the end of item.update()
						item.visible = item.visible && step.hasChosen();
					}
				});
			}
		});

		// Update static items
		this.items.items.forEach(item => {
			if (item.type == 'static'){
				item.update(); 
			}
		});
	}

	updatePlaceholders(){
		// Update totals placeholders
		// console.log( 'UPDATING: Totals', customizer.totals );
		for (const k in customizer.totals){
			this.updatePlaceholder(k, customizer.totals[k]);
		}

		// Update dynamic items (static items updated before totals get computed)
		// console.log( 'UPDATING: Dynamics' );
		this.items.items.forEach(item => {
			if (item.type == 'dynamic'){
				item.update();
			}
		});
	}
}

class BillingItem{
	constructor(data){
		this.id = '';
		this.type = '';
		// this.subtype = '';
		this.name = '';
		this.description = '';
		this.value = '';
		this.visible = true;
		this.fulfilled = true;
		this.is_fee = false;
		this.updateCallback = null;
		this.conditions = [];

		// Set initial data
		this.set(data);

		// this.placeholderable = data.placeholderable; // not needed
		this.computedValue = null;
		this.displayValue = '';

		// Conditions
		this.conditions = new CustomizerConditionService(this.conditions);
	}

	set(data){
		for (const key in data){
			if (this.hasOwnProperty(key)){
				this[key] = data[key];
			}
		}
	}

	getComputedValue(){
		// Skip if static
		if (this.type == 'static'){
			return this.value;
		}

		let value = this.value;
		let computedValue = 0;

		// Replace placeholders
		for (const key in customizer.billing.placeholders){
			value = value.replaceAll('{' + key + '}', customizer.billing.placeholders[key]);
		}

		// Stop if not all placeholders were resolved
		if (value.indexOf('{') !== -1 || value.indexOf('{') !== -1){
			return computedValue;
		}
		
		// Replace decimal operator
		value = value.replaceAll(',', '.');

		// Stop if not a valid operation (need regexp)
		//...

		// Compute
		eval('value = ' + value + ';');

		return value.sanitize(2);
	}

	update(){
		// Update fulfilled state
		this.fulfilled = this.conditions.fulfilled();

		// Get computed value
		this.computedValue = this.getComputedValue();

		// Update placeholers
		customizer.billing.updatePlaceholder(this.id, this.computedValue);

		// Update visibility
		this.visible = this.fulfilled && this.computedValue !== 0;
		
		// Format
		this.displayValue = typeof this.computedValue === 'string' ? this.computedValue : this.computedValue.toPrice();

		// Hook for custom function
		if (this.updateCallback){
			this.updateCallback();
		}
	}
}

// Storyline
class Storyline{
	constructor(){
		// this.items = [];
		this.sections = [];
		// this.map = {};
		this.current;
		this.scrollTimeout;
		// this.wheel;
		// this.preview = new StorylinePreview(); < 2.0
		this.input = document.querySelector('.cmz-storyline-input');
		// this.panel = document.querySelector('.cmz-storyline-panel-inner');
		// this.ready = false;
		this.changedRef = false;
		// todo: step sections (step sections titles are viisble even if no step visible inside)

		// Scrolldown panel when open
		/*
		this.input.addEventListener('change', () => {
			if (this.input.checked){
				this.panel.scrollTo(0, this.panel.firstElementChild.offsetHeight);
			}
		});
		*/
	}

	init(){
		// Spot
		const spot = new StorylineSection('spot');
		spot.items.push(new StorylineItem_Spot(customizer.spot));
		this.sections.push(spot);

		// Steps
		const structuredItems = customizer.steps.getStructuredSteps();

		structuredItems.forEach(item => {
			const section = new StorylineSection(item.section.id);

			item.steps.forEach(step => {
				if (step.type == 'checkbox'){
					step.options.forEach(option => {
						section.items.push(new StorylineItem_Checkbox(step, option, this.sections.length));
					});

					return;
				}

				if (step.type == 'multibool'){
					// section.isMultibool = true;

					step.options.forEach(option => {
						section.items.push(new StorylineItem_Multibool(step, option, this.sections.length));
					});

					return;
				}

				section.items.push(new StorylineItem_Step(step));
			});

			this.sections.push(section);
		});

		// Summary
		const summary = new StorylineSection('summary');
		summary.items.push(new StorylineItem_Summary(customizer.summary));
		this.sections.push(summary);

		// Init preview < 2.0
		// this.preview.init();

		// Wheel
		// this.wheel = new StorylineWheel();

		document.addEventListener('cmzChoiceChanged', (e) => {
			this.changedRef = e.detail;
		});

		// Update state
		this.update();

		// Create trigger once storyline initialized
		this.trigger = new StorylineTrigger();

		// First load scroll if form already filled
		this.forward();
	}

	update(){
		// Reset current
		if (this.current){
			this.current.setCurrent(false);

			// Update siblings if multibool
			if (this.current.ref.type == 'multibool' || this.current.ref.type == 'checkbox'){
				this.sections[this.current.sectionIndex].setAllCurrent(false);
			}
		}

		this.current = null;

		// Update all items
		this.sections.forEach(section => {
			let sectionHasActiveItems = false;

			section.items.forEach(item => {
				// Update items
				item.update();

				if (item.isCompleted() && item.isFulfilled()){
					sectionHasActiveItems = true;
				}
				
				// Set current
				if (!this.current && !item.isCompleted() && item.isFulfilled()){
					this.current = item;
					sectionHasActiveItems = true;
				}
			});

			// Update section visibility
			section.node.classList.toggle('has-active-items', sectionHasActiveItems);

		});

		// If no current at this stage, assume that all steps are completed and go to summary
		if (!this.current){
			// this.current = this.sections[0].items[0];
			this.current = this.sections[this.sections.length-1].items[this.sections[this.sections.length-1].items.length-1];
		}

		this.current.setCurrent(true);

		// Update siblings if multibool
		if (this.current.ref.type == 'multibool' || this.current.ref.type == 'checkbox'){
			this.sections[this.current.sectionIndex].setAllCurrent(true);
		}

		// Scroll if completed
		if (this.changedRef && this.changedRef.completed && this.changedRef.autoscroll){
			this.forward();
		}

		// Update preview < 2.0
		// this.preview.update();
	}

	forward(delay = 250){
		this.scrollTo(this.current, delay);
	}

	scrollTo(item, delay = 0){
		this.scrollTimeout = setTimeout(() => {
			// item.ref.node.scrollIntoView({behavior: 'smooth'});
			(item.ref.anchor || item.ref.node).scrollIntoView({block: 'start', behavior: 'smooth'});
		}, delay);
	}
}

class StorylineTrigger{
	constructor(){
		this.node = document.querySelector('.cmz-storyline-trigger-wrap');
		this.number = this.node.querySelector('.cmz-storyline-trigger-number');
		this.visible = false;

		// Show wheel when steps visible
		window.addEventListener('scroll', () => {
			this.update();
		});
		
		this.update();
	}

	update(){
		// if (window.innerWidth < 1180) return;

		let totalIndex = 0;
		let currentIndex = 0;

		// Remove all unscreen first (unoptimized because loop run twice, but easy fix for checkbox issue described below
		customizer.storyline.sections.forEach(section => {
			section.items.forEach(item => {
				item.ref.node.classList.remove('onscreen');
			})
		});
		
		customizer.storyline.sections.forEach(section => {
			section.items.forEach(item => {
				// Get total (old comment: Update index only for fullfilled items (useful for css translate))
				if (item.isFulfilled()){
					totalIndex++;
				}
				
				// Get current
				if (!currentIndex && item.isOnscreen() && item.isFulfilled()){
					item.ref.node.classList.add('onscreen'); // why is this added by StorylineTrigger?
					currentIndex = totalIndex;
					return;
				}

				// Moved to its own loop because create issue with checkbox (each step create several storyline items, therefore, the last item was overriting the onScreen value of its siblings (onScreen was always false)
				// item.ref.node.classList.remove('onscreen');
			})
		});

		// Set onscreen

		// Update total number (mobile)
		this.number.setAttribute('data-current', Math.max(currentIndex - 1, 1).toString().padStart(2, '0'));
		this.number.setAttribute('data-total', Math.max(totalIndex - 1, 1).toString().padStart(2, '0'));

		// Show or hide component
		const threshold = window.innerWidth < 1024 ? .75 : .25;
		customizer.spot.node.getBoundingClientRect().bottom <= window.innerHeight * threshold ? this.show() : this.hide();
	}
/*
	stepOnScreen(){
		const b = this.ref.node.getBoundingClientRect();
		return b.top < window.innerWidth / 2 && b.bottom > window.innerWidth / 2;
	}
*/
	show(){
		if (this.visible){
			return;
		}

		this.visible = true;
		this.node.classList.add('visible');
	}

	hide(){
		if (!this.visible){
			return;
		}

		this.visible = false;
		this.node.classList.remove('visible');
	}
}

class StorylineSection{
	constructor(id){
		this.id = id; // section id (global)
		// this.index = customizer.storyline.sections.length; // section storyline index
		this.node = document.querySelector('.cmz-storyline-section[data-id="' + id + '"]');
		this.items = [];
	}

	setAllCurrent(bool){
		this.items.forEach(item => {
			item.setCurrent(bool);
		});
	}
}

class StorylineItem{
	init(){
		/** 
		 * Set by child
		 * 
		 * this.ref
		 * this.id
		 * this.option (multibool, checkbox)
		 * this.sectionIndex (multibool, checkbox)
		 */

		this.node = document.querySelector('.cmz-storyline-item[data-id="' + this.id + '"]');
		this.name = this.node.querySelector('.cmz-storyline-item-name');
		this.value = this.node.querySelector('.cmz-storyline-item-value');
		this.img = this.node.querySelector('.cmz-storyline-item-img');

		// this.preview = new StorylinePreviewItem(this);

		this.node.addEventListener('click', (e) => {
			e.preventDefault();
			customizer.storyline.scrollTo(this, 125);
			
			if (customizer.storyline.input.checked){
				customizer.storyline.input.click();
			}
		});

		// Add to preview
		// customizer.storyline.preview.add(this.dot, this.node);

		// Detect when ref goes onscreen (to turn storyline wheel) #tryhard /20
		/*
		window.addEventListener('scroll', () => {
			const b = this.ref.node.getBoundingClientRect();
			let onscreen = false;

			if (customizer.storyline.wheel.scrollGoesDown && b.top <= window.innerHeight / 2 && b.top > 0){
				onscreen = true;
			}
			else if (!customizer.storyline.wheel.scrollGoesDown && b.bottom <= window.innerHeight / 2 && b.bottom > 0){
				onscreen = true;
			}

			if (onscreen != this.onscreen){
				this.onscreen = onscreen;
				// const eventName = this.onscreen ? 'storylineItemEnterScreen' : 'storylineItemLeaveScreen';
				window.dispatchEvent(new CustomEvent('storylineItemEnterScreen', {detail: {item: this}}));
			}
		});
		*/

	}

	update(){
		this.isCompleted() ? this.setCompletion('completed') : this.setCompletion('uncompleted');
		this.isFulfilled() ? this.setCondition('fulfilled') : this.setCondition('unfulfilled');

		// Update child
		if (this.onParentUpdate){
			this.onParentUpdate();
		}
	}

	setCompletion(state){
		this.ref.node.setAttribute('data-completion', state);
		this.node.setAttribute('data-completion', state);
		// this.preview.node.setAttribute('data-completion', state);
	}

	setCondition(state){
		this.ref.node.setAttribute('data-condition', state);
		this.node.setAttribute('data-condition', state);
		// this.preview.node.setAttribute('data-condition', state);
	}

	setCurrent(bool){
		this.ref.node.classList.toggle('current', bool);
		this.node.classList.toggle('current', bool);
		// this.preview.node.classList.toggle('current', bool);
	}

	isCompleted(){
		return this.ref.completed;
	}

	isFulfilled(){
		return this.ref.fulfilled;
	}

	isOnscreen(){
		const threshold = window.innerWidth < 1024 ? (window.innerHeight * .3 + window.innerWidth * .5625) : window.innerHeight * .5;
		const b = this.ref.node.getBoundingClientRect();
		return b.top < threshold && b.bottom > threshold;
	}
}

class StorylineItem_Spot extends StorylineItem{
	constructor(ref){
		super();
		this.ref = ref;
		this.id = 'spot';
		this.init();
	}

	onParentUpdate(){
		this.value.innerHTML = '';
		this.img.innerHTML = '';

		if (!this.ref.hasChosen()){
			return;
		}

		// Name
		this.name.innerHTML = customizer.spot.chosen.getName();
		
		// Image
		const src = customizer.spot.getCurrentImg();

		if (src){
			this.img.innerHTML = `<img src="${src}" alt="${this.name}">`;
		}

		// Floor
		// if (customizer.spot.floors.multifloor){
			this.value.innerHTML += _cmz('Planta') + ' ' + customizer.spot.chosen.floor;
		// }

		// Primary specs
		const specs = customizer.spot.chosen.specs.getAll();

		customizer.spot.chosen.specs.forEach(spec => {
			if (spec.importance == 3){
				this.value.innerHTML += ' - ' + spec.getDisplayValue();
			}
		});

		// this.value.innerHTML += customizer.spot.chosen.size.toArea();
	}
}

class StorylineItem_Step extends StorylineItem{
	constructor(ref){
		super();
		this.ref = ref;
		this.id = ref.id;
		this.init();
	}

	onParentUpdate(){
		// Value
		this.value.innerHTML = this.ref.getDisplayValue();
		
		// Image
		const src = this.ref.getCurrentImg();
		this.img.innerHTML = src ? `<img src="${src}" alt="${this.name}">` : '';
	}
}

class StorylineItem_Multibool extends StorylineItem{
	constructor(ref, option, sectionIndex){
		super();
		this.ref = ref;
		this.id = option.id;
		this.sectionIndex = sectionIndex; // section index (specific to storyline)
		this.option = option
		this.init();
	}

	onParentUpdate(){
		this.value.innerHTML = this.option.input.checked ? _cmz('Sí') : _cmz('No');
	}
}

class StorylineItem_Checkbox extends StorylineItem{
	constructor(ref, option, sectionIndex){
		super();
		this.ref = ref;
		this.id = option.id;
		this.sectionIndex = sectionIndex; // section index (specific to storyline)
		this.option = option;
		this.init();
	}

	onParentUpdate(){
		this.value.innerHTML = this.option.input.checked ? _cmz('Sí') : _cmz('No');
	}
}

class StorylineItem_Summary extends StorylineItem{
	constructor(ref){
		super();
		this.id = 'summary';
		this.ref = ref;
		this.init();
	}
}
/* < 2.0
class StorylinePreview{
	init(){
		this.node = document.querySelector('.cmz-storyline-trigger');
		this.number = this.node.querySelector('.cmz-storyline-trigger-number');
		this.items = [];

		// Spot
		this.items.push(new StorylinePreviewItem(customizer.spot));

		// Steps
		customizer.steps.forEach(step => {
			this.items.push(new StorylinePreviewItem(step));
		})

		// Summary
		this.items.push(new StorylinePreviewItem(customizer.summary));

		// Show wheel when steps visible
		window.addEventListener('scroll', () => {
			this.updateVisibility();
			this.updateView();

		});
		
		this.updateVisibility();
	}

	update(){
		// if (window.innerWidth < 1180) return;

		// Update fulfilled states
		this.items.forEach(item => {
			item.updateState();
		})

		// Update view
		this.updateView();
	}

	updateView(){
		// if (window.innerWidth < 1180) return;

		let visibleItemsIndex = 0;
		let activeFounded = false;

		for (let i = 0; i < this.items.length; i++){
			if (!activeFounded && this.items[i].onScreen() && this.items[i].isFulfilled()){
				activeFounded = true;

				// Set active
				this.setActive(this.items[i], visibleItemsIndex);

				// Update current number (mobile)
				this.number.setAttribute('data-current', visibleItemsIndex + 1);
				// return;
			}

			// Update index only for fullfilled items (useful for css translate)
			if (this.items[i].isFulfilled()){
				visibleItemsIndex++;
			}
		}

		// Update total number (mobile)
		this.number.setAttribute('data-total', visibleItemsIndex); // Not + 1 as for current because visibleItemsIndex starts at 0 but summary shold not be counted
	}

	add(item){
		this.items.push(item);
	}

	setActive(item, index){
		if (this.active){
			// Interupt if item already active
			if (this.active.id == item.id){
				return;
			}

			this.active.deactivate();
		}

		this.active = item;

		this.active.activate();

		this.node.style.setProperty('--step-index', index);
		this.node.setAttribute('data-active-item', this.active.id);
	}

	updateVisibility(){
		return customizer.spot.node.getBoundingClientRect().bottom <= window.innerHeight * .25 && customizer.summary.node.getBoundingClientRect().top > window.innerHeight * .5 ? this.show() : this.hide();
	}

	show(){
		if (this.visible){
			return;
		}

		this.visible = true;
		this.node.classList.add('visible');
	}

	hide(){
		if (!this.visible){
			return;
		}

		this.visible = false;
		this.node.classList.remove('visible');
	}
}

class StorylinePreviewItem{
	constructor(ref){
		this.id = ref.id;
		this.ref = ref;
		this.node = document.querySelector('.cmz-storyline-trigger-inner > div[data-id="' + this.id + '"]');
	}

	onScreen(){
		const b = this.ref.node.getBoundingClientRect();
		return b.top < window.innerWidth / 2 && b.bottom > window.innerWidth / 2;
	}

	isFulfilled(){
		return this.ref.fulfilled;
	}

	updateState(){
		this.node.classList.toggle('unfulfilled', !this.isFulfilled());
	}

	activate(){
		this.node.classList.add('active');
	}

	deactivate(){
		this.node.classList.remove('active');
	}
}
*/
/*
class StorylineWheel{
	constructor(){
		this.node = document.querySelector('.cmz-storyline-trigger');
		this.previousScroll = 0;
		this.scrollGoesDown;

		// Show wheel when steps visible
		window.addEventListener('scroll', () => {
			this.updateVisibility();
		});
		
		this.updateVisibility();

		// Keep track of scroll direction
		window.addEventListener('scroll', () => {
			this.scrollGoesDown = window.pageYOffset > this.previousScroll;
			this.previousScroll = window.pageYOffset;
		});

		// Turn wheel on step change
		window.addEventListener('storylineItemEnterScreen', () => {
			const className = this.scrollGoesDown ? 'next' : 'previous';
			this.node.classList.add(className);
		});

		// Remove classes when animation finishes
		this.node.addEventListener('transitionend', () => {
			this.node.classList.remove('next');
			this.node.classList.remove('previous');
		})
	}

	updateVisibility(){
		return customizer.spot.node.getBoundingClientRect().bottom <= window.innerHeight * .25 ? this.show() : this.hide();
	}

	show(){
		if (this.visible){
			return;
		}

		this.visible = true;
		this.node.classList.add('visible');
	}

	hide(){
		if (!this.visible){
			return;
		}

		this.visible = false;
		this.node.classList.remove('visible');
	}
}
*/

// Prices
class Prices{
	init(){
		this.billing = new PricesBilling();
		this.mortgage = customizer.settings.show_mortgage_simulator ? new PricesMortgage() : null;
		this.summary = new PricesSummary(); // Omnibar
	}

	update(){
		// Billing
		this.billing.update();

		// Update summary total
		this.summary.update();

		// Mortgage
		if (customizer.settings.show_mortgage_simulator){
			this.mortgage.setCartValue(customizer.totals.total);
			this.mortgage.update();
		}
	}
}

class PricesSummary{
	constructor(){
		this.node = document.querySelector('.cmz-prices-summary');
		this.total = document.querySelector('.cmz-prices-summary-total .cmz-prices-summary-item-value > span');
		
		if (customizer.settings.show_mortgage_simulator){
			this.deposit = document.querySelector('.cmz-prices-summary-deposit .cmz-prices-summary-item-value > span');
			this.monthly = document.querySelector('.cmz-prices-summary-monthly .cmz-prices-summary-item-value > span');
			this.rate = document.querySelector('.cmz-prices-summary-rate .cmz-prices-summary-item-value > span');
		}

		this.visible = false;

		// Update summary when mortage is updated
		window.addEventListener('cmzMortgageUpdated', this.updateMortgage.bind(this));

		window.addEventListener('scroll', () => {
			this.updateVisibility();
		})
		
		this.updateVisibility();
	}

	update(){
		this.total.innerHTML = customizer.totals.total.toPrice();
	}

	updateMortgage(){
		this.monthly.innerHTML = customizer.prices.mortgage.values.mortgage.monthly.toPrice();
		this.deposit.innerHTML = customizer.prices.mortgage.values.mortgage.deposit.toPrice();
		this.rate.innerHTML = (customizer.prices.mortgage.values.mortgage.interest.rate * 100).toLocale();
	}

	updateVisibility(){
		const threshold = window.innerWidth < 1024 ? .75 : .25;
		customizer.spot.node.getBoundingClientRect().bottom <= window.innerHeight * threshold ? this.show() : this.hide();
	}

	show(){
		if (this.visible){
			return;
		}

		this.visible = true;
		this.node.classList.add('visible');
	}

	hide(){
		if (!this.visible){
			return;
		}

		this.visible = false;
		this.node.classList.remove('visible');
	}
}

class PricesBilling{
	constructor(){
		// this.node = document.querySelector('.cmz-prices-detail-items tbody');
		this.items = [];

		document.querySelectorAll('.cmz-prices .cmz-prices-billing-item').forEach(node => {
			this.items.push({
				node: node,
				id: node.getAttribute('data-id'),
				description: node.querySelector('.cmz-prices-billing-item-description'),
				value: node.querySelector('.cmz-prices-billing-item-value'),
			});
		});
	}

	update(){
		this.items.forEach(item => {
			if (customizer.billing.items.has(item.id)){
				const data = customizer.billing.items.get(item.id);

				item.description.innerHTML = data.description;
				item.value.innerHTML = data.displayValue;
				item.node.classList.toggle('is-hidden', !data.visible);
			}
		});
		/*
		return;

		this.node.innerHTML = Object.values(customizer.billing.getItems()).map(item => {
			return item.visible ? '<tr><td><b>' + item.name + '</b>' + item.description + '</td><td>' + item.displayValue + '</td></tr>' : '';
		}).join('');
		*/
	}
}

class PricesMortgage{
	constructor(){
		this.settings = {
			taxes: .1,
			minimumDepositRate: .2, // Percentage of the cart recommended for deposit
		};

		this.values = {
			product: {
				cart: 0,
				total: 0,
			},
			taxes: {
				notary: 0,
				registery: 0,
				agency: 0,
				tax: {
					rate: 0,
					amount: 0,
				},
				valuation: 0,
				total: 0,
			},
			mortgage: {
				deposit: 0,
				loan: 0,
				monthly: 0,
				interest: {
					type: '',
					rate: 0,
					amount: 0,
				},
			},
			total: 0,
		}
		
		this.form = document.querySelector('.cmz-mortgage-form');

		this.inputs = {
			cart: {
				node: this.form.elements['mortgage-cart'],
				edited: false,
			},
			deposit: {
				node: this.form.elements['mortgage-deposit'],
				edited: false,
			},
			years: {
				node: this.form.elements['mortgage-years'],
				edited: false,
			},
			interestRateFixed: {
				node: this.form.elements['mortgage-interest-rate-fixed'],
				edited: false,
			},
			// interestType: this.form.elements['mortgage-interest-type'], // @disabled variable mortage rate
			// interestTypeVariable: this.form.elements['mortgage-interest-type'][0], // @disabled variable mortage rate
			// interestTypeFixed: this.form.elements['mortgage-interest-type'][1], // @disabled variable mortage rate
			// interestRateVariable: this.form.elements['mortgage-interest-rate-variable'], // @disabled variable mortage rate
		}

		this.edited = {
			cart: false,
			deposit: false,
			years: false,
			// interestType: false,
			// interestTypeVariable: false,
			// interestTypeFixed: false,
			// interestRateVariable: false,
			interestRateFixed: false,
		}

		this.summary = {
			product: {
				cart: document.querySelector('.cmz-mortgage-summary-cart'),
				taxes: document.querySelector('.cmz-mortgage-summary-taxes'),
				total: document.querySelector('.cmz-mortgage-summary-total-house'),
			},
			mortgage: {
				deposit: document.querySelector('.cmz-mortgage-summary-deposit'),
				loan: document.querySelector('.cmz-mortgage-summary-loan'),
				interest: document.querySelector('.cmz-mortgage-summary-interest'),
				monthly: document.querySelector('.cmz-mortgage-summary-monthly'),
			},
			taxes: {
				notary: document.querySelector('.cmz-mortgage-summary-taxes-notary'),
				registery: document.querySelector('.cmz-mortgage-summary-taxes-registery'),
				agency: document.querySelector('.cmz-mortgage-summary-taxes-agency'),
				tax: document.querySelector('.cmz-mortgage-summary-taxes-tax'),
				valuation: document.querySelector('.cmz-mortgage-summary-taxes-valuation'),
				total: document.querySelector('.cmz-mortgage-summary-taxes-total'),
			},
			total: document.querySelector('.cmz-mortgage-summary-total'),
		}

		// Add listeners
		for (const k in this.inputs){
			if ('HTMLInputElement' == this.inputs[k].node.constructor.name){
				this.inputs[k].node.setAttribute('data-input-key', k);
				this.inputs[k].node.addEventListener('input', this.update.bind(this));
			}
		}

		// Bind numbers <> ranges
		this.form.querySelectorAll('.cmz-form-row').forEach(row => {
			const number = row.querySelector('.cmz-form-field-number .cmz-form-input');
			const range = row.querySelector('.cmz-form-field-range .cmz-form-input');

			if (number && range){
				new InputBundle([number, range]);
			}
		});
	}

	update(e){
		if (e && e.detail == 'noUpdate'){
			return;
		}

		// Set input as edited
		if (e){
			this.inputs[e.target.getAttribute('data-input-key')].edited = true;
		}
		
		// Update deposit max amount
		this.inputs.deposit.node.max = this.inputs.cart.node.value;
		
		if (!this.inputs.deposit.edited){
			// Update deposit input value if never edited by user before
			this.inputs.deposit.node.value = (this.inputs.cart.node.value * this.settings.minimumDepositRate).sanitize(2);

			// Dispatch event to trigger range update (InputBundle) with noUpdate tag to prevent calling this funciton again (infinite loop)
			this.inputs.deposit.node.dispatchEvent(new CustomEvent('input', {detail: 'noUpdate'}));
		}

		// Get inputs value
		this.values.product.cart = parseFloat(this.inputs.cart.node.value);
		this.values.mortgage.deposit = parseFloat(this.inputs.deposit.node.value);
		this.values.mortgage.years = parseFloat(this.inputs.years.node.value);
		// this.values.mortgage.interest.type = this.inputs.interestType.node.value; // @disabled variable mortage rate
		// this.values.mortgage.interest.rate = this.values.mortgage.interest.type == 'fixed' ? (this.inputs.interestRateFixed.value / 100).sanitize() : (this.inputs.interestRateVariable.value / 100).sanitize(); // @disabled variable mortage rate
		this.values.mortgage.interest.rate = (this.inputs.interestRateFixed.node.value / 100).sanitize(); // @disabled variable mortage rate

		// Calculate taxes
		this.values.taxes.notary = 951;
		this.values.taxes.registery = 474;
		this.values.taxes.agency = 300;
		this.values.taxes.tax.rate = this.getTaxRate();
		this.values.taxes.tax.amount = this.values.product.cart * this.values.taxes.tax.rate;
		this.values.taxes.valuation = 400;
		this.values.taxes.total = this.values.taxes.notary + this.values.taxes.registery + this.values.taxes.agency + this.values.taxes.tax.amount + this.values.taxes.valuation;

		// Calculate product
		this.values.product.total = this.values.product.cart + this.values.taxes.total;

		// Calculate mortgage
		this.values.mortgage.loan = Math.max(this.values.product.total - this.values.mortgage.deposit, 0);
		this.values.mortgage.monthly = this.getMonthly();
		this.values.mortgage.interest.amount = (this.values.mortgage.monthly * (this.values.mortgage.years * 12)) - this.values.mortgage.loan;
		// this.values.mortgage.interest.amount = (this.values.mortgage.loan * this.values.mortgage.interest.rate) * this.values.mortgage.years;
		// this.values.monthly = Math.round(this.values.total / (this.values.mortgage.years * 12));
		
		// Calculate total
		this.values.total = this.values.product.total + this.values.mortgage.interest.amount;


		// Update view
		this.summary.product.cart.innerHTML = this.values.product.cart.toPrice();
		this.summary.product.taxes.innerHTML = this.values.taxes.total.toPrice();
		this.summary.product.total.innerHTML = this.values.product.total.toPrice();

		this.summary.taxes.notary.innerHTML = this.values.taxes.notary.toPrice();
		this.summary.taxes.registery.innerHTML = this.values.taxes.registery.toPrice();
		this.summary.taxes.agency.innerHTML = this.values.taxes.agency.toPrice();
		this.summary.taxes.tax.innerHTML = this.values.taxes.tax.amount.toPrice();
		this.summary.taxes.valuation.innerHTML = this.values.taxes.valuation.toPrice();
		this.summary.taxes.total.innerHTML = this.values.taxes.total.toPrice();

		this.summary.mortgage.deposit.innerHTML = this.values.mortgage.deposit.toPrice();
		this.summary.mortgage.loan.innerHTML = this.values.mortgage.loan.toPrice();
		this.summary.mortgage.interest.innerHTML = this.values.mortgage.interest.amount.toPrice();
		this.summary.mortgage.monthly.innerHTML = this.values.mortgage.monthly.toPrice();
		this.summary.total.innerHTML = this.values.total.toPrice();

		// Update form UI
		// Toggle deposit notice
		this.inputs.deposit.node.parentNode.parentNode.parentNode.classList.toggle('too-low', this.values.mortgage.deposit < this.values.product.cart * this.settings.minimumDepositRate);

		// Update rate according to type (@disabled variable mortage rate)
		// this.inputs.interestRateVariable.parentNode.parentNode.setAttribute('data-interest-type', this.values.mortgage.interest.type);

		window.dispatchEvent(new CustomEvent('cmzMortgageUpdated'));
	}

	setCartValue(value){
		this.inputs.cart.node.value = value;
		this.inputs.cart.node.max = value * 2;
		this.inputs.cart.node.dispatchEvent(new CustomEvent('input', {detail: 'noUpdate'}));
	}

	getTaxRate(){
		if (this.values.product.cart <= 300000){
			return .08;
		}
		else if (this.values.product.cart <= 500000){
			return .09;
		}

		return .1;
	}

	getMonthly(){
		let c = this.values.mortgage.loan;
		let i = this.values.mortgage.interest.rate / 12;
		let n = this.values.mortgage.years * 12;

		// c = 200000;
		// i = 3 / 100 / 12;
		// n = 20 * 12;
		// C * (((1 + i)^n) * i) / ((1 + i)^n - 1)
		return c * ((Math.pow((1 + i), n)) * i) / (Math.pow((1 + i), n) - 1);
	}
}

// Product
class Product{
	constructor(data){
		this.id = '';
		this.name = '';
		this.floor = '';
		
		this.price = 0;
		this.size = 0;
		this.specs = [];

		this.status = 'available';
		this.status_label = 'Disponible';
		this.available = true;
		this.booked = false;
		this.filtered = false;
		this.chosen = false;

		// let data = JSON.parse(this.input.getAttribute('data-product'));

		if (data){
			for (let k in data){
				this[k] = data[k];
			}
		}

		this.input = document.querySelector('#cmz-step-product-input-' + this.id);
		this.popup = document.querySelector('#cmz-step-product-popup-' + this.id);
		// this.planPopup = document.querySelector('#cmz-spot-plan-product-input-' + this.id);

		// Build specs
		this.specs = new ProductSpecService(this.specs);

		// Set available state
		this.nodes = {
			productPlan3D: null, // added by Spot when plan loaded
			productPlan2D: null, // added by Spot when plan loaded
			minicard: document.querySelector('label[for="cmz-spot-plan-product-input-' + this.id + '"]'),
			grid: document.querySelector('.cmz-spot-grid-product[data-id="' + this.id + '"]'),
			list: document.querySelector('.cmz-spot-list-tr[data-id="' + this.id + '"]'),
			planProduct: null, // added by PlanServices
		};
		/*
		setTimeout(() => {
			this.nodes.productPlan3D = customizer.spot.plan.getProduct(this.id);
		})*/
	}

	init(){
		// Remember popup open
		this.popup.addEventListener('change', () => {
			// Close plan popup
			// customizer.spot.inputs.planPreviewNone.checked = true;

			// customizer.spot.setPreview(this.id);
			document.dispatchEvent(new CustomEvent('cmzSpotSettingsChanged'));
		});

		// Set chosen event
		this.input.addEventListener('change', () => {
			const delay = window.innerWidth < 1024 ? 0 : 600;

			// Close plan popup before without delay (bit dirty but fine)
			if (customizer.spot.inputs.planPreviewNone){
				// customizer.spot.inputs.planPreviewNone.checked = true;
				if (!customizer.spot.inputs.planPreviewNone.checked){
					customizer.spot.inputs.planPreviewNone.click();
				}
			}

			setTimeout(() => { // Wait for CSS transition
				customizer.spot.setChosen(this);
			}, delay);
		});
	}

	toggleState(state, add){
		if (this.nodes.grid){
			this.nodes.grid.classList.toggle('is-' + state, add);
		}

		if (this.nodes.list){
			this.nodes.list.classList.toggle('is-' + state, add);
		}

		if (this.nodes.minicard){ // allow cmz to work without plan
			this.nodes.minicard.classList.toggle('is-' + state, add);
		}

		if (this.nodes.planProduct){
			this.nodes.planProduct.setState(state, add);
		}

		// if (this.nodes.productPlan3D){
		// 	this.nodes.productPlan3D.setState(state, add);
		// }

		// if (this.nodes.productPlan2D){
		// 	this.nodes.productPlan2D.setState(state, add);
		// }
		
		if (customizer.spot.floors?.multifloor){
			const floor = customizer.spot.floors.getFloor(this.floor);
			
			if (floor){
				floor.updateState();
			}
		}
	}

	addState(state){
		this.toggleState(state, true);
	}

	removeState(state){
		this.toggleState(state, false);
	}

	filter(){
		if (this.filtered){
			return;
		}

		this.filtered = true;
		this.toggleState('filtered', this.filtered);
	}

	unfilter(){
		if (!this.filtered){
			return;
		}

		this.filtered = false;
		this.toggleState('filtered', this.filtered);
	}

	setOrder(index){
		if (this.nodes.grid){
			this.nodes.grid.style.setProperty('order', index);
		}
		
		if (this.nodes.list){
			this.nodes.list.style.setProperty('order', index);
		}
	}

	getShortName(){
		return this.name;
	}

	getName(){
		return _cmz('Piso') + ' ' + this.name;
	}
}

// Spot
class Spot{
	init(){
		this.id = 'spot';
		this.node = document.querySelector('.cmz-spot');
		this.img = 0;
		this.completed = false;
		// this.multichoice = false;
		this.fulfilled = true;
		this.autoscroll = true;
		this.products = [];
		this.floors;
		this.chosen;
		this.plans;
		
		this.display = {
			form: null,
			previous: {},
			settings: {
				view: '',
				sort: '',
				sortby: '',
				light: '',
				filters: {},
				modals: {
					filters: false,
					preview: '',
				}
			},
		};

		if (!this.node){
			return;
		}

		this.inputs = {
			filters: this.node.querySelector('#cmz-spot-filters-popup'),
			sort: this.node.querySelector('#cmz-spot-sort-popup'),
			view: this.node.querySelector('#cmz-spot-view-popup'),
			previewNone: this.node.querySelector('#cmz-step-product-popup-none'),
			productNone: this.node.querySelector('#cmz-step-product-input-none'),
			planPreviewNone: this.node.querySelector('#cmz-spot-plan-product-none'),
			viewPlan3D: this.node.querySelector('#cmz-spot-view-input-plan3d'),
			viewPlan2D: this.node.querySelector('#cmz-spot-view-input-plan2d')
		};

		// Add to customzier map
		customizer.map[this.id] = this;

		// Display options
		// this.display.form = this.node.querySelector('.cmz-spot-display-options');
		this.display.form = document.querySelector('.cmz-steps-form');

		// Create filters
		this.filters = new SpotFilterServices();

		// Collect form data on first load (used by session)
		this.collect();

		// Products
		this.products = CMZ.products.map(data => {
			// Add plan product object
			const product = new Product(data);
			product.init(); // Product need to be init after being added to this.items, otherwise floor status is not updated correctly

			// Set chosen on first load
			if (product.chosen){
				this.chosen = product;
				this.completed = true;
			}

			return product;
		});

		if (CMZ.selector.plan3D || CMZ.selector.plan2D){
			this.plans = new PlanService(this);

			document.addEventListener('cmzSpotPlanProductStateChanged', (e) => {
				const product = this.getProduct(e.detail.productId);

				if (product){
					product.toggleState(e.detail.stateName, e.detail.stateValue);
				}
			})
		}

		// Update height when screen changes (fix height when mobile navbar slides up)
		/*document.documentElement.style.setProperty('--height', window.innerHeight + 'px');
		
		window.addEventListener('resize', () => {
			document.documentElement.style.setProperty('--height', window.innerHeight + 'px');
		});*/

		// Update settings when form submitted
		this.display.form.addEventListener('submit', (e) => {
			// Bail early if submitted by checkout button
			if (e.submitter?.classList?.contains('cmz-summary-book')){
				return;
			}

			e.preventDefault();
			document.dispatchEvent(new CustomEvent('cmzSpotSettingsChanged'));
			// this.update();
		});

		// Submit form every time an input changes
		this.display.form.querySelectorAll('.cmz-spot-display-option').forEach(input => {
			input.addEventListener('input', () => {
				this.display.form.requestSubmit();
			});
		})

		// Bind display switchers to inputs
		this.node.querySelectorAll('input[data-bindto]').forEach(input => {
			const selector = '#' + input.getAttribute('data-bindto');
			const target = document.querySelector(selector);

			if (target){
				// Initial state
				input.checked = target.checked;

				// Change listener
				input.addEventListener('change', () => {
					target.click();
				});
				
				if (target.name == 'cmz[spot][view]'){
					target.addEventListener('change', () => {
						// @todo fix pressing button on mobile dont change on desktop
						// console.log(target, input, target.checked, input.checked);
						// target.click();
					});
				};
			};
		});

		// Change sort order when sortby button clicked twice
		this.node.querySelectorAll('.cmz-spot-sort-large-button').forEach(label => {
			label.addEventListener('click', (e) => {
				if (e.target == label){ // prevent input inside label to fire too
					const input = label.firstElementChild;

					// Toggle sort order
					if (input.checked){
						this.node.querySelector('#cmz-spot-sort-input-asc:not(:checked), #cmz-spot-sort-input-desc:not(:checked)').click();
					}
				}

			});
		});

		// Update modal states
		this.inputs.filters.addEventListener('change', e => {
			document.dispatchEvent(new CustomEvent('cmzSpotSettingsChanged'));
			// this.display.settings.modals.filters = e.target.checked;
			// customizer.session.update();
		});

		this.inputs.previewNone.addEventListener('change', e => {
			document.dispatchEvent(new CustomEvent('cmzSpotSettingsChanged'));
			// this.unsetPreview();
		});

		// Add unchoose event
		this.inputs.productNone.addEventListener('change', () => {
			// Unchoose
			this.unsetChosen();

			// Load plan if not initialized yet
			if (this.inputs.viewPlan3D?.checked){
				this.plans.plan3D.initialize();
			}

			// Load plan if not initialized yet
			if (this.inputs.viewPlan2D?.checked){
				this.plans.plan2D.initialize();
			}
		});

		// Expend light buttons on mobile
		this.node.querySelectorAll('.cmz-spot-plan-toolbar-light > label').forEach(label => {
			label.addEventListener('click', e => {
				if (e.target != label) return;
				label.parentNode.classList.toggle('opened');
			});
		})

		// First load update (should not be needed if PHP properly built)
		// this.update(false);

		document.addEventListener('cmzSpotSettingsChanged', e => {
			this.update();
		})

		// Update view on first load
		// this.updateProductsView();
	}

	collect(){
		const data = new FormData(this.display.form);

		// Collect form values
		this.display.settings.view   = data.get('cmz[spot][view]');
		this.display.settings.sort   = data.get('cmz[spot][sort]');
		this.display.settings.sortby = data.get('cmz[spot][sortby]');
		this.display.settings.light  = data.get('cmz[spot][light]');

		this.filters.setValues(data);

		this.filters.forEach(filter => {
			this.display.settings.filters[filter.id] = filter.getValue();
		});

		this.display.settings.modals.filters  = data.get('cmz[spot][modals][filters]');
		this.display.settings.modals.preview  = data.get('cmz[spot][modals][preview]');

		// console.log( Object.fromEntries(data.entries()) );
	}

	update(){
		console.log( 'update' );
		const previous = JSON.parse(JSON.stringify(this.display.settings)); // Deep copy of object

		// Collect form data
		this.collect();

		// Apply changes only on things that changed (over-optimized?)
		const changed = {
			filters: JSON.stringify(this.display.settings.filters) != JSON.stringify(previous.filters),
			sort: this.display.settings.sort != previous.sort || this.display.settings.sortby != previous.sortby,
			view: this.display.settings.view != previous.view,
		};

		// Filter products
		if (changed.filters){
			this.filters.update();
		}

		// Sort products
		if (changed.sort){
			const up = this.display.settings.sort == 'desc' ? 1 : -1;
			const down = this.display.settings.sort == 'desc' ? -1 : 1;

			[...this.products].sort((productA, productB) => {
				const specA = productA.specs.get(this.display.settings.sortby);
				const specB = productB.specs.get(this.display.settings.sortby);

				// Empty specs are always at the end
				if (!specA && !specB) return 0;
				if (!specA) return 1;
				if (!specB) return -1;

				if (specA.value == specB.value) return 0;
				
				return specA.value < specB.value ? up : down;
			}).forEach((product, index) => {
				product.setOrder(index);
			});

			// Close mobile popup
			this.inputs.sort.checked = false;

			// Update mobile button icon
			this.node.querySelector('.cmz-spot-button-sort > label').setAttribute('data-icon', this.display.settings.sort);
		}

		// View
		if (changed.view){
			// Close mobile popup
			this.inputs.view.checked = false;

			// Update mobile button icon
			this.node.querySelector('.cmz-spot-button-view > label').setAttribute('data-icon', this.display.settings.view);

			// Load plans
			if (this.inputs.viewPlan3D?.checked){
				this.plans.plan3D.initialize();
			}

			if (this.inputs.viewPlan2D?.checked){
				this.plans.plan2D.initialize();
			}
		}

		customizer.session.update();
	}

	getProduct(id){
		return id ? this.products.find(product => product.id == id) : false;
	}
/*
	setPreview(productId){
		this.display.settings.modals.preview = productId;
		customizer.session.update();
	}

	unsetPreview(){
		this.display.settings.modals.preview = '';
		customizer.session.update();
	}
*/
	setChosen(product){
		if (this.chosen){
			this.chosen.chosen = false;
		}

		this.chosen = product;
		this.completed = true;

		// Close product popup
		this.inputs.previewNone.checked = true;
		// this.inputs.planPreviewNone.checked = true;	 // set before timeout	
		// this.node.getElementById('cmz-step-product-popup-none').click(); // not use to avoid update sesion twice (here and when cmzChoiceChanged is fired)
		
		document.dispatchEvent(new CustomEvent('cmzSpotSettingsChanged'));
		document.dispatchEvent(new CustomEvent('cmzChoiceChanged', {detail: this}));
		// this.closeDetailInput.click();
	}

	unsetChosen(){
		if (this.chosen){
			this.chosen.chosen = false;
		}

		this.chosen = undefined;
		this.completed = false;
		
		document.dispatchEvent(new CustomEvent('cmzChoiceChanged', {detail: this}));
	}

	hasChosen(){
		return typeof this.chosen !== 'undefined';
	}

	getName(){
		return this.chosen ? this.chosen.name : '';
	}

	getPrice(){
		return this.chosen ? this.chosen.price : 0;
	}

	getCurrentImg(){
		return this.chosen ? this.chosen.img : this.img;
	}

	scrollIntoView(e){
		e.preventDefault();
		this.node.scrollIntoView({behavior: 'smooth'});
	}
}

class SpotFilterServices{
	constructor(){
		// this.form = customizer.spot.node.querySelector('form');
		this.form = document.querySelector('.cmz-steps-form');
		this.node = customizer.spot.node.querySelector('.cmz-spot-filters')
		this.input = customizer.spot.node.querySelector('#cmz-spot-filters-input'); 
		this.modifiedInputs = [];
		this.filters = {};
		this.data;

		CMZ.filters.forEach(filter => {
			switch (filter['type']){
				case 'range':
					this.filters[filter['id']] = new SpotFilter_Range(filter);
				break;

				case 'radio':
					this.filters[filter['id']] = new SpotFilter_Radio(filter);
				break;
				/*
				case 'bool':
					this.filters[filter['id']] = new SpotFilter_Boolean(filter);
				break;
				*/
			}

		});

		// Reset buttons
		this.node.querySelectorAll('*[value="reset-filters"]').forEach(resetButton => {
			resetButton.addEventListener('click', () => {
				// this.form.reset();

				// Reset filter inputs
				this.node.querySelectorAll('.cmz-form-input').forEach(input => {
					const defaultValue = input.getAttribute('data-default');

					if (input.type == 'radio'){
						input.checked = input.value == defaultValue;
					}
					else{
						input.value = defaultValue;
					}
				});

				// Update view
				// this.onFilterChange();
			});
		});

		// Apply on change
		this.node.querySelectorAll('.cmz-form-input').forEach(input => {
			input.addEventListener('change', e => {
				e.preventDefault(); // Don't remember why this is here
				// this.onFilterChange();
			});
		});

		// Set filter value on first load
		// this.setValues();

		// Apply on first load
		// this.apply()
	}

	getFormValue(filterId){

	}

	setValues(formData){
		// const formData = new FormData(this.form);

		Object.values(this.filters).forEach(filter => {
			// Set values
			if (filter.type == 'range'){
				filter.setValue({
					min: formData.get(filter.formName + '[min]'),
					max: formData.get(filter.formName + '[max]'),
				});
			}
			else{
				filter.setValue(formData.get(filter.formName));
			}
		})
	}

	// onFilterChange(){
		// Update filter values
		// this.setValues();

		// this.apply(); // Called by Spot()
	// }

	update(){
		let resultCount = 0;

		// Apply
		customizer.spot.products.forEach(product => {
			let passFilters = true;

			Object.values(this.filters).forEach(filter => {
				/*
				if (filter.id == 'without-queue' && filter.value && product.queue.length){ // Dirty, need a proper implementation where filters are not necesarrely bind to specs
					passFilters = false;
					return;
				}
				*/
				if (filter.id == 'availability' && filter.value == 'available' && !product.available){
					console.log( product );
					passFilters = false;
					return;
				}

				const spec = product.specs.get(filter.id)

				if (spec && !filter.specPassFilter(spec)){
					passFilters = false;
				}
			});

			passFilters ? product.unfilter() : product.filter();

			if (passFilters){
				resultCount++;
			}
		});

		// Move to next available floor
		if (customizer.spot.plans?.floors){
			customizer.spot.plans.floors.goToClosestAvailable();
		}

		// Update button counter
		const filterCount = Object.values(this.filters).filter(filter => !filter.isDefault()).length;
		
		customizer.spot.node.classList.toggle('has-no-result', !resultCount);
		customizer.spot.node.classList.toggle('has-filters', filterCount);
		customizer.spot.node.style.setProperty('--filters-count', filterCount);
	}

	get(id){
		return this.filters[id];
	}

	forEach(callback){
		Object.values(this.filters).forEach(filter => {callback(filter)})
	}
}

class SpotFilter{
	constructor(data){
		this.id = data['id'];
		this.type = data['type'];
		this.formName = `cmz[spot][filters][${this.id}]`;
	}

	getValue(){
		return this.value;
	}
}

class SpotFilter_Range extends SpotFilter{
	constructor(data){
		super(data);

		// this.min = data['min'];
		// this.max = data['max'];

		this.default = {
			min: parseFloat(data['default']['min']),
			max: parseFloat(data['default']['max']),
		}

		this.reset();
	}

	reset(){
		this.value = {...this.default};
	}

	setValue(value){
		this.value.min = parseFloat(value?.min);
		this.value.max = parseFloat(value?.max);
	}
/*
	setValue(value, id){
		if (id.indexOf('[min]') > -1){
			this.value.min = parseFloat(value);
		}
		else if (id.indexOf('[max]') > -1){
			this.value.max = parseFloat(value);
		}
	}
*/

	isDefault(){
		return this.value.min === this.default.min && this.value.max === this.default.max;
	}

	specPassFilter(spec){
		const specValues = {
			min: spec.type == 'range' ? spec.min : spec.value,
			max: spec.type == 'range' ? spec.max : spec.value,
		};

		if (specValues.min < this.value.min) return;
		if (specValues.max > this.value.max) return;

		return true;
	}
}

class SpotFilter_Radio extends SpotFilter{
	constructor(data){
		super(data);

		// this.min = data['min'];
		// this.max = data['max'];

		this.isNumberType = data['min'] !== null && data['max'] !== null; // dirty but work
		this.default = 'any';

		this.reset();
	}

	reset(){
		this.value = this.default;
	}

	setValue(value){
		// const isNumberRadio = this.min !== null && this.max !== null; // dirty but work
		this.value = value != 'any' && this.isNumberType ? parseFloat(value) : value;
	}

	isDefault(){
		return this.value === this.default;
	}

	specPassFilter(spec){
		if (this.value == 'any') return true;

		if (spec.type == 'range'){
			return this.value >= spec.min && this.value <= spec.max;
		}

		return spec.value == this.value;

		/*
		const specValues = {
			min: spec.type == 'range' ? spec.min : spec.value,
			max: spec.type == 'range' ? spec.max : spec.value,
		};

		return specValues.min > this.value  || specValues.max < this.value;
		*/
	}
}
/*
class SpotFilter_Boolean extends SpotFilter{
	constructor(data){
		super(data);
		this.default = false;
		this.reset();
	}

	reset(){
		this.value = this.default;
	}

	setValue(value){
		this.value = value ? true : false;
	}

	isDefault(){
		return this.value === this.default;
	}

	specPassFilter(spec){
		return !(this.value && !spec.value);
	}
}
*/
/*
class SpotPlanNavigation{ // @todo move to plan.js and import it
	constructor(spot){
		this.focusItem = null;
		// this.plan = new SpotPlanEngine(spot.node, spot.display.settings);
		this.nav = spot.node.querySelector('.cmz-spot-plan-nav');
		
		const touch = {
			start: {
				x: null,
				y: null,
			},
			diff: {
				x: 0,
				y: 0,
			},
			shift: 0,
			current: 0,
		};

		this.nav.addEventListener('touchstart', (e) => {
			touch.start.y = e.touches[0].clientY;
			touch.start.x = e.touches[0].clientX;
			touch.diff.y = 0;

			// this.touch.timestart = Date.now();
			// this.touch.scroll = this.slider.scrollTop;
		});

		this.nav.addEventListener('touchmove', (e) => {
			// Bail early if touch didn't start on the element
			if (touch.start.y === null) return;

			// Get diff
			touch.diff.x = touch.start.x - e.touches[0].clientX;
			touch.diff.y = touch.start.y - e.touches[0].clientY;

			// Bail early if horizontal scroll intended
			if (Math.abs(touch.diff.x) > Math.abs(touch.diff.y)){
				return;
			}

			// Get diff (clamped between [0;88])
			// touch.diff.y = Math.max(0, Math.min(88, touch.start.y - e.touches[0].clientY));
			touch.shift = Math.max(0, Math.min(88, touch.current + touch.diff.y));

			const moveUp = touch.diff.y >= 0;

			// if (touch.diff.y > 50){
			if (moveUp && touch.shift >= 50){
				// Open completely
				touch.shift = 88;
				this.focusActiveItem();
			}
			else if (!moveUp && touch.shift < 50){
				// Close completely
				touch.shift = 0;
				this.unfocus();
			}
			else{
				// Slide freely
				this.nav.style.setProperty('--translate', touch.shift + 'px');
				spot.node.style.setProperty('--plan-nav-translate', touch.shift + 'px');
				this.nav.setAttribute('data-status', 'drag');
			}

		});
		
		this.nav.addEventListener('touchend', (e) => {
			// Reset touch start
			touch.start.y = null;
			
			// Save current position
			touch.current = touch.shift;
			// touch.current = touch.current + touch.diff.y;
				
			// Define final state if slide let in the limbo
			if (this.nav.getAttribute('data-status') == 'drag'){
				this.nav.setAttribute('data-status', touch.shift >= 50 ? 'open' : 'close');
				// this.nav.setAttribute('data-status', 'close');
			}
			// touch.timeDown = null;

			// Move to item if significant drag detected
			if (touch.diff.y > 5){
				// this.scrollToItem(this.current.item); // @todo only fire this if dragged, not on click
			}
		});

		// Minicard
		this.minicads = {
			slider: spot.node.querySelector('.cmz-spot-plan-products-minicards'),
			activeItemId : null, // item in center of slider
			items: spot.products.filter(product => {
				return product.available; // Remove unavailable products
			}).map(product => {
				return {
					id: product.id,
					node: product.nodes.minicard,
					// node: spot.node.querySelector('label[for="cmz-spot-plan-product-input-' + product.id + '"]')
				}	
			})
		};

		this._scrollMinicardSliderTo = () => {this.scrollMinicardSliderTo();}

		// Set first item activeItemId by default
		if (this.minicads.items.length){
			this.minicads.activeItemId = this.minicads.items[0].id;
		}

		const center = window.innerWidth / 2;
		let debounce;

		// Focus product on slider move
		this.minicads.slider.addEventListener('scroll', () => {
			for (let i = 0; i < this.minicads.items.length; i++) {
				const item = this.minicads.items[i];
				const {left, right} = item.node.getBoundingClientRect();

				if (left <= center && right >= center){
					if (this.minicads.activeItemId != item.id){
						this.minicads.activeItemId = item.id;

						clearTimeout(debounce);

						// Focus on product
						debounce = setTimeout(() => {
							// Remove autoscroll before firing focusActiveItem() to prevent item to be focused twice
							document.removeEventListener('cmzPlanProductFocused', this._scrollMinicardSliderTo);
								
							// Focus
							this.focusActiveItem();
							
							// Add autoscroll back
							document.addEventListener('cmzPlanProductFocused', this._scrollMinicardSliderTo);
							// this.plan.focusProduct(this.plan.getProduct(item.id), false);

							// Focus camera
							// this.plan.moveCameraTo(item.id);
							
							// Highlight product
							// this.plan.setInteraction('focus', this.plan.getProduct(item.id)); // Cradoc =/
						}, 400);
					}

					break;
				}
			}
		});

		// Open minicard slider when product clicked (focus mode)
		document.addEventListener('cmzPlanProductClicked', (e) => {
			// const planProduct = spot.plans.getProduct(e?.detail?.productId);
			this.nav.setAttribute('data-status', 'open');
		});

		// Scroll minicards slider when product focused
		document.addEventListener('cmzPlanProductFocused', (e) => {
			const spotProduct = spot.getProduct(e.detail.product.id);
			this.scrollMinicardSliderTo(spotProduct?.nodes?.minicard);
			// this.scrollMinicardSliderTo(e.detail.product?.minicard);
		});

		if (window.innerWidth < 1024){
			document.addEventListener('cmzSpotPlan3DLoaded', () => {
				this.focusActiveItem();
			});
		}
	}

	// initialize(){
		// this.plan.initialize();
	// }

	scrollMinicardSliderTo(minicard){
		if (!minicard) return;

		this.minicads.slider.scrollTo({
			top: 0,
			left: minicard.offsetLeft,
			behavior: 'smooth'
		});
	}

	focusActiveItem(){
		this.nav.setAttribute('data-status', 'open');

		// Focus activeItemId item
		if (this.minicads.activeItemId){
			// Hook for 3D and 2D plans
			document.dispatchEvent(new CustomEvent('cmzSpotPlanProductFocus', {detail: {productId: this.minicads.activeItemId}}))
			// this.plan.focusProduct(this.plan.getProduct(this.minicads.activeItemId), false);
		}
	}
	
	unfocus(){
		this.nav.setAttribute('data-status', 'close');

		// Hook for 3D and 2D plans
		document.dispatchEvent(new CustomEvent('cmzSpotPlanProductUnfocus'));
		// this.plan.unfocus();
	}
}*/

class ProductSpecService{
	constructor(data){
		this.specs = [];
		this.map = {};

		for (let i = 0; i < data.length; i++) {
			let spec;

			switch (data[i].type){
				case 'range': spec = new ProductSpec_Range(data[i]); break;
				case 'bool' : spec = new ProductSpec_Boolean(data[i]); break;
				default     : spec = new ProductSpec(data[i]); break;
			}

			this.specs.push(spec);
			this.map[spec.id] = i;
		}
	}

	get(id){
		return this.specs[this.map[id]] ?? false;
	}

	getAll(){
		return this.specs;
	}

	forEach(callback){
		this.specs.forEach(spec => {callback(spec)})
	}
}

class ProductSpec{
	constructor(data){
		this.id = 0;
		this.type = 'number';
		this.name = '';
		this.unit = '';
		this.value = '';
		this.icon = '';
		// this.filterable = false;
		this.importance = 1;

		for (let k in data){
			if (this.hasOwnProperty(k)){
				this[k] = data[k];
			}
		}
	}

	getDisplayValue(){
		if (this.unit == 'price'){
			return this.value.toPrice();
		}

		if (this.unit == 'area'){
			return this.value.toArea();
		}

		return this.value;
	}

	getRange(){
		return {min: this.value, max: this.value};
	}
}

class ProductSpec_Range extends ProductSpec{
	constructor(data){
		super(data);

		this.type  = 'range';
		this.min   = data.min;
		this.max   = data.max;
		this.value = this.min + '-' + this.max;
	}

	getRange(){
		return {min: this.min, max: this.max};
	}
}

class ProductSpec_Boolean extends ProductSpec{
	constructor(data){
		super(data);
		this.type = 'bool';
	}

	getDisplayValue(){
		return this.value ? _cmz('Sí') : _cmz('No');
	}
}
/*
class ProductGraphic{
	constructor(svg){
		// this.node = customizer.spot.node.querySelector('#cmz-spot-plan-product-' + product.id);
		// this.svg = customizer.spot.node.querySelector('#product-' + product.id);
		this.svg = svg;
		this.valid = this.svg ? true : false;

		if (!this.valid){
			return;
		}

		this.hovered = this.svg.classList.contains('hover');


		// Get anchors position
		// let summary = this.getAnchorPosition(this.svg.querySelector(':scope > *:nth-child(4)'), customizer.spot.viewbox);
		// let preview = this.getAnchorPosition(this.svg.querySelector(':scope > *:nth-child(5)'), customizer.spot.viewbox);
		// let summary = this.getAnchorPosition(this.svg.querySelector(':scope > *[id^="number"]'), customizer.spot.viewbox);
		// let preview = this.getAnchorPosition(this.svg.querySelector(':scope > *[id^="popup"]'), customizer.spot.viewbox);
		// this.node.style.setProperty('--anchor-summary-x', summary.x + '%');
		// this.node.style.setProperty('--anchor-summary-y', summary.y + '%');
		// this.node.style.setProperty('--anchor-preview-x', preview.x + '%');
		// this.node.style.setProperty('--anchor-preview-y', preview.y + '%');

		this.svg.addEventListener('mouseenter', () => {
			if (!this.hovered){
				this.hovered = true;
				this.svg.classList.toggle('hover', true);
				// this.node.classList.toggle('hover', true);
			}
		});

		this.svg.addEventListener('mouseleave', () => {
			if (this.hovered){
				this.hovered = false;
				this.svg.classList.toggle('hover', false);
				// this.node.classList.toggle('hover', false);
			}
		});
	}

	enable(){
		// this.node.classList.remove('disabled');
		this.svg.classList.remove('disabled');
	}

	disable(){
		// this.node.classList.add('disabled');
		this.svg.classList.add('disabled');
	}
	
	// getAnchorPosition(svgCircleElement, viewbox){
		// if (!['SVGCircleElement', 'SVGEllipseElement'].includes(svgCircleElement.constructor.name)){
			// console.warn('Error en el plano: La ancla con nombre "' + svgCircleElement.id + '" tiene que ser un circulo (SVGCircleElement) o una elipse (SVGEllipseElement), ahora es un ' + svgCircleElement.constructor.name + ')', svgCircleElement);
			// return {x: 0, y: 0}
		// }

		// return {
			// x: Math.round( (((svgCircleElement.cx.baseVal.value - viewbox.x) / (viewbox.width - viewbox.x)) * 100) * 1000 ) / 1000,
			// y: Math.round( (((svgCircleElement.cy.baseVal.value - viewbox.y) / (viewbox.height - viewbox.y)) * 100) * 1000 ) / 1000
		// };
	// }
	
}

class ProductList{
	constructor(product){
		this.node = document.querySelector('#cmz-spot-list-product-' + product.id);
		this.label = this.node.querySelector('.cmz-spot-list-action-label label');
	}
}
*/
// Steps
class Steps{
	init(){
		this.steps = [];
		this.sections = [];

		CMZ.sections.forEach(data => {
			this.sections.push(new StepsSection(data));
		});

		CMZ.steps.forEach(data => {
			let step;

			switch (data.type){
				case 'ol':
					step = new Step_OrderedList(data);
				break;

				default:
					step = new Step(data);
				break;
			}

			this.steps.push(step);
		});
	}

	forEach(callback){
		this.steps.forEach(step => {callback(step)})
	}

	getStructuredSteps(){
		let structuredItems = [];

		if (!this.sections.length || !this.steps.length){
			return structuredItems;
		}

		// Create first section
		let item = {section: this.sections[this.steps[0].section], steps: []};

		this.steps.forEach(step => {
			if (step.section !== item.section.id){
				// Add previous section
				structuredItems.push(item);

				// Create new section
				item = {section: this.sections[step.section], steps: []};
			}

			item.steps.push(step);
		});

		// Add last section
		structuredItems.push(item);

		return structuredItems;
	}

	update(){
		this.steps.forEach(step => {
			step.update();
		});
	}
}

class StepsSection{
	constructor(data){
		this.id = data.id;
		this.name = data.name;
	}
}

class Step{
	constructor(data){
		this.section = 0;
		this.id = '';
		this.name = '';
		this.slug = '';
		this.type = '';
		this.img = 0; // fallback img if no option chosen
		this.required = 1; // Number of requiered options
		this.options = []; 
		this.conditions = []; 
		this.autoscroll = false;
		// this.multichoice = false;
		this.onscreen = false;
		this.completed = false;
		this.fulfilled = true;
		// const data = JSON.parse(this.node.getAttribute('data-args'));

		if (data){
			for (const k in data){
				if (typeof this[k] !== 'undefined'){
					this[k] = data[k];
				}
			}
		}

		// Temporary overide data passed by php until @todo conditions and @todo validation are implemented server side
		this.completed = false;
		this.fulfilled = true;

		this.node = document.querySelector('#cmz-step-' + this.id);
		this.anchor = this.node.querySelector('.cmz-step-anchor');
		this.chosen = [];
		this.total = 0;
		this.values = [];
		// this.multichoice = ['ol', 'multibool'].includes(this.type); // Wether it is possible to select several option
		// this.autoscroll = !this.multichoice;

		// Add to customzier map
		customizer.map[this.id] = this;

		// Conver option to object
		const options = this.options;

		switch (this.type){
			case 'ol':
				this.options = new StepOptionsService_OrderedList(options, this);
			break;

			default:
				this.options = new StepOptionsService(options, this);
			break;
		}

		// this.options.init(options, this);
		// this.doAction('optionInitialized');

		// Conditions
		this.conditions = new CustomizerConditionService(this.conditions);

		// Next button
		this.nextButton = this.node.querySelector('.cmz-step-next');

		if (this.nextButton){
			this.nextButton.addEventListener('click', (e) => {
				// Not required steps are considered completed when the 'next step' button is clicked
				if (!this.required){
					this.completed = true;
					customizer.update(); // overkill but simpler
					// this.update();
				}

				const delay = this.autoscroll ? 0 : undefined;
				customizer.storyline.forward(delay);
				e.preventDefault();
			});
		}

		this.update();
	}

	doAction(name){
		if (typeof this[name] == 'function'){
			this[name]();
		}
	}

	update(){
		// Update condition
		const wasFulfilled = this.fulfilled;
		this.fulfilled = this.conditions.fulfilled();

		// Update options
		this.options.update();

		// Unfulfilled if none of the option meet requirements
		if (this.options.areAllUnfulfilled()){
			this.fulfilled = false;
		}

		// Fulfilled state changed: Warn user 
		// /!\ too late because option.update() already changed the input value without asking for confirmation => option.update() need to be edited so it doesn't change option input value yet. Use a 'valueWillChange' variable instead. Then, display the message to user and then change the option input value if s/he agree to the changes
		// Or, backup all customizer choices and restore them if choices canceled? (maybe better because the option described below won't check the condition properly because the option input won't be updated)
		if (this.fulfilled != wasFulfilled){
			// Display message...
		}

		// Update step
		this.chosen = this.options.chosen;
		this.total = this.options.total;
		this.values = this.options.values;

		if (this.required || this.hasChosen()){ // Not required status is updated upon 'next step' click, except if it already has a value
			this.completed = this.chosen.length >= this.required;
		}

		// this.updateView();

		// document.dispatchEvent(new CustomEvent('cmzChoiceChanged', {detail: this}));
	}

	updateView(){
		// this.node.classList.toggle('completed', this.completed);
	}

	updatefulfillState(){
	}

	hasChosen(){
		return this.chosen.length > 0;
	}

	getTotal(){
		return this.total;
	}

	getCurrentImg(){
		return this.options.img || this.img;
	}

	isFree(){
		return this.getTotal() === 0;
	}
/*
	reset(){
		console.log('Reseting', this.name);
		this.options.removeChosen();
		this.update();
	}
*/
	getChosenMeta(key){
		return this.chosen.map(option => {
			return option[key];
		});
	}

	getDisplayValue(){
		return this.values.join(', ');
	}

	getSummaryContent(){
		let data = {
			name: this.name,
			subtitle: this.getDisplayValue(),
		};

		if (this.getTotal() && this.type != 'boolean'){
			data.value = this.getTotal().toPrice();
		}

		if (this.type == 'boolean'){
			// @todo: boolean support
			// data.toggle = true;
		}
		else{
			data.anchor = {
				href: this.node.id,
				action: this.scrollIntoView.bind(this)
			}
		}

		return data;
	}

	scrollIntoView(e){
		e.preventDefault();
		this.anchor.scrollIntoView({block: 'start', behavior: 'smooth'});
	}
}

class Step_OrderedList extends Step{
	constructor(data){
		super(data);
	}
}

class StepOptionsService{
	constructor(options, step){
		this.options = [];
		// }

		// init(options, step){
		for (let i = 0; i < options.length; i++) {
			let option = new StepOption(options[i], step);

			// Add to group
			this.options.push(option);

			// Add to customzier map
			customizer.map[option.id] = option;
		}

		this.details = new StepOptionsDetails(this.options, step);

		// Init children (option specific type logic)
		/*
		if (typeof this.onParentInitialized == 'function'){
			this.onParentInitialized(step);
		}
		*/
	}

	reset(){
		this.chosen = [];
		this.total = 0;
		this.values = [];
		this.img = 0;
	}

	update(){
		// Hook for ol options
		if (typeof this.beforeUpdate == 'function'){
			this.beforeUpdate();
		}

		this.reset();

		this.options.forEach(option => { // @todo respect ol order
			// Check conditions
			option.update();

			if (option.chosen){
				this.chosen.push(option);
				this.total += option.price;
				this.values.push(option.name);
				this.img = option.img;
			}
		});
	}

	areAllUnfulfilled(){
		for (let i = this.options.length - 1; i >= 0; i--) {
			if (this.options[i].fulfilled){
				return false;
			}
		}

		return this.options.length ? true : false;
	}

	forEach(callback){
		this.options.forEach(option => {callback(option)})
	}
}

class StepOptionsDetails{
	constructor(options, step){
		this.current = 0;
		this.options = options;
		this.input = step.node.querySelector('.cmz-step-options-details-trigger');
		this.slider = step.node.querySelector('.cmz-step-options-details-items-inner');
		this.previous = step.node.querySelector('.cmz-step-options-details-nav-previous > div');
		this.next = step.node.querySelector('.cmz-step-options-details-nav-next > div');

		if (this.previous){
			this.previous.addEventListener('click', this.backward.bind(this));
		}

		if (this.next){
			this.next.addEventListener('click', this.forward.bind(this));
		}

		// Update pagination (mobile)
		if (this.slider){
			this.slider.addEventListener('scroll', () => {
				if (window.innerWidth >= 1024) return;

				const threshold = window.innerWidth * .5;

				this.optionsAvailable.forEach(option => {
					const b = option.details.node.getBoundingClientRect();
					option.details.pagination.classList.toggle('is-active', b.left <= threshold && b.right >= threshold);
				});

			});
		}
	}

	init(id){
		this.reset();

		window.requestAnimationFrame(() => {
			this.goTo(this.optionsAvailable.findIndex(option => option.id == id), 'instant');
		})
	}

	reset(){
		// Reset pagination
		if (this.optionsAvailable){
			this.optionsAvailable.forEach(option => option.details.pagination.classList.remove('is-active'));
		}

		// Reset available options
		this.optionsAvailable = this.options.filter(option => option.fulfilled);
	}

	goTo(index, behavior = 'smooth'){
		this.current = index;
		this.optionsAvailable[index].details.pagination.classList.add('is-active');
		this.optionsAvailable[index].details.node.scrollIntoView({inline: 'center', block: 'center', behavior: behavior});
	}

	backward(){
		let index = this.current > 0 ? this.current - 1 : this.optionsAvailable.length - 1;
		this.goTo(index);
	}

	forward(){
		let index = this.current < this.optionsAvailable.length - 1 ? this.current + 1 : 0;
		this.goTo(index);
	}
}

class StepOptionsService_OrderedList extends StepOptionsService{
	constructor(options, step){
		super(options, step);
		// }

		// onParentInitialized(step){
		this.optionsNode = step.node.querySelector('.cmz-step-options');
		this.selection = [];
		this.max = step.required;

		// Extends options
		this.options.forEach(option => {
			option.numberNode = option.input.parentNode.querySelector('.cmz-step-option-selectmark');
			option.order = option.input.getAttribute('data-order') || this.options.length;
			option.order = parseInt(option.order);
			
			// Update attributes and input name
			option.setOrder = function (order){
				this.order = order;
				this.numberNode.setAttribute('data-order', order + 1);
				this.input.name = 'cmz[steps][' + step.id + '][' + order + ']';
			}
		});

		this.updateOrders();
	}

	beforeUpdate(){
		this.updateOrders();
	}

	updateOrders(){
		// Sort options with old order
		this.options = this.options.sort((a,b) => a.order - b.order);

		let order = 0;

		// Update orders of chosen options
		this.options.forEach(option => {
			if (option.input.checked){
				option.setOrder(order);
				order++;
			}
		})

		// Set order of not chosen option to next number
		this.options.forEach(option => {
			if (!option.input.checked){
				option.setOrder(order);
			}
		})

		// Fade out if finished
		this.optionsNode.classList.toggle('maxed-out', order >= this.max);
	}
	/*
	addToSelection(item){
		console.log('Add to selection', item);
		// Bail if max already reached out
		if (this.selection.length >= this.max){
			return;
		}

		this.selection.push(item);

		// this.updateView();
	}

	removeFromSelection(item){
		console.log('Remove from selection', item);
		let selection = [];

		this.selection.forEach(selected => {
			if (item.input != selected.input){
				selection.push(selected);
			}
		})

		this.selection = selection;

		// this.updateView();
	}

	updateView(){
		console.log(this.selection);

		// Set order to selected options
		for (let i = 0; i < this.selection.length; i++) {
			this.selection[i].setOrder(i);
		}

		// Update unselect options to next available number
		for (let i = 0; i < this.options.length; i++) {
			if (!this.options[i].input.checked){
				this.options[i].setOrder(this.selection.length);
			}
		}

		// console.log(this.options.map(option => {return {name: option.name, order: option.order}}));
		this.options.sort((a,b) => a.order - b.order);
		// console.log(this.options.map(option => {return {name: option.name, order: option.order}}));

		// Fade out if finished
		this.optionsNode.classList.toggle('maxed-out', this.selection.length >= this.max);
	}
	*/
}

class StepOption{
	constructor(args, step){
		// this.id = 0;
		this.step = step;
		this.id = '';
		this.name = '';
		this.price = 0;
		this.img = '';
		this.chosen = false;
		this.conditions = [];
		this.fulfilled = true;
		this.order;

		if (args){
			for (const k in args){
				if (typeof this[k] !== 'undefined'){
					this[k] = args[k];
				}
			}
		}

		this.node = this.step.node.querySelector('#cmz-option-' + this.id);
		this.input = this.node.querySelector('#cmz-option-input-' + this.id);
		// this.imgs = this.step.node.querySelector('.cmz-step-imgs[data-option="' + this.id + '"]');
		this.imgs = this.step.node.querySelector('.cmz-step-gallery-' + this.id);

		if (!this.input){
			console.warn('Dev: Option input no found: #cmz-option-input-' + this.id);
			return;
		}

		// Update gallery on hover
		if (this.imgs){
			this.node.addEventListener('mouseenter', () => {
				this.step.options.forEach(option => {
					// this.setGalleryActive(option)
					if (option.imgs){
						option.imgs.classList.remove('active');
					}
				})

				this.imgs.classList.add('active');
			})
		}

		this.input.addEventListener('change', () => {
			// step.update();
			document.dispatchEvent(new CustomEvent('cmzChoiceChanged', {detail: this.step}));

			// Close details
			// if (this.details.node){
				this.step.options.details.input.checked = false;
			// }
		});

		// Details
		this.details = {
			node: this.step.node.querySelector('.cmz-step-option-details[data-id="' + this.id + '"]'),
			pagination: this.step.node.querySelector('.cmz-step-options-details-pagination > div[data-id="' + this.id + '"]'),
		};

		if (this.details.node){
			// Scroll to this option when details opened
			this.node.querySelector('.cmz-step-option-details-trigger').addEventListener('click', () => {
				this.step.options.details.init(this.id);
			})
		}

		// Conditions
		this.conditions = new CustomizerConditionService(this.conditions);
	}

	update(){
		// Check for condition
		this.fulfilled = this.step.fulfilled && this.conditions.fulfilled();

		if (!this.fulfilled){
			// console.warn('Chosen option removed because became unfulfilled', this);
			this.input.checked = false;
		}

		// Update chosen state
		this.chosen = this.input.checked;

		// Update view
		let fulfilled = this.fulfilled ? 'fulfilled' : 'unfulfilled';
		this.node.setAttribute('data-condition', fulfilled);

		// Update gallery
		if (this.imgs){
			this.imgs.classList.toggle('is-unfulfilled', !this.fulfilled);
		}

		// Update details
		if (this.details.node){
			this.details.node.classList.toggle('is-chosen', this.chosen);
			this.details.node.setAttribute('data-condition', fulfilled);
			this.details.pagination.setAttribute('data-condition', fulfilled);
		}
	}
}

// Conditions
class CustomizerConditionService{
	constructor(conditionGroups){
		this.conditionGroups = [];

		conditionGroups.forEach(conditionGroup => {
			this.conditionGroups.push(new CustomizerConditionGroup(conditionGroup));
		});
	}

	has(){
		return this.conditionGroups.length ? true : false;
	}

	fulfilled(){
		// Fulfilled if empty
		if (!this.conditionGroups.length){
			return true;
		}

		// Fulfill if at least one condition group meet requirements (OR)
		for (let i = this.conditionGroups.length - 1; i >= 0; i--) {
			if (this.conditionGroups[i].fulfilled()){
				// console.log('Condition meet, skip other condition group', this.conditionGroups[i])
				return true;
			}
		}
		
		return false;
	}
}

class CustomizerConditionGroup{
	constructor(conditions){
		this.conditions = [];

		conditions.forEach(condition => {
			this.conditions.push(new CustomizerCondition(condition));
		});
	}

	fulfilled(){
		// Fulfill if all conditions meet requirements (AND)
		for (let i = this.conditions.length - 1; i >= 0; i--) {
			if (!this.conditions[i].fulfilled()){
				return false;
			}
		}
		
		return true;
	}
}

class CustomizerCondition{
	constructor(data){
		// this.id 	  = data['id'];
		this.operator = data['operator'];
		this.values   = data['values']; // Multiple values are treated like OR

		this.item = customizer.getItem(data['id']);

		if (!this.item){
			console.warn('Condition error: No item found with id', data['id']);
			return;
		}
	}

	fulfilled(){
		let chosen = [];

		if (this.item.id == 'spot'){
			chosen = this.item.hasChosen() ? [this.item.chosen.id] : [];
		}
		else{
			chosen = this.item.getChosenMeta('id');
		}

		switch (this.operator){
			case '==':
				for (let i = this.values.length - 1; i >= 0; i--) {		
					if (chosen.includes(this.values[i])){
						// console.log('Condition id match', this.values, this.operator, chosen);
						return true;
					}
				}
			break;

			case '!=': 
				for (let i = this.values.length - 1; i >= 0; i--) {		
					if (chosen.includes(this.values[i])){
						return false;
					}
				}
				
				return true;
			break;
		}

		// console.log('Condition no id match founded', this.values, this.operator, chosen);
		return false;
	}
}

// Summary
class Summary{
	constructor(){
		this.id = 'summary';
		this.fulfilled = true;
		this.node = document.querySelector('#cmz-summary');
		this.spot;
		this.steps = [];
		this.breakdown = [];
		this.placeholders = {};
		this.billing = [];
	}

	init(){
		// Spot
		this.spot = new SummarySpot();

		// Steps
		customizer.steps.getStructuredSteps().forEach(item => {
			let section = new SummarySteps(item.section.id);

			item.steps.forEach(step => {
				if (step.type == 'info'){
					return;
				};

				if (step.type == 'multibool' || step.type == 'checkbox'){
					step.options.forEach(option => {
						section.add(new SummaryNode_Boolean(option));
					});

					return;
				}

				section.add(new SummaryNode_Step(step));
			});

			this.steps.push(section);
		});

		// Billing
		document.querySelectorAll('.cmz-summary-billing .cmz-summary-option').forEach(node => {
			this.billing.push({
				node: node,
				id: node.getAttribute('data-id'),
				description: node.querySelector('.cmz-summary-option-subtitle'),
				value: node.querySelector('.cmz-summary-option-value'),
			});
		});
	}

	setPlaceholder(key, value){
		this.placeholders['{' + key + '}'] = value;
	}

	update(){
		// Spot
		this.spot.update();

		// Steps
		this.steps.map(section => {
			section.update();
		});
		
		// Billing
		this.billing.forEach(item => {
			if (customizer.billing.items.has(item.id)){
				const data = customizer.billing.items.get(item.id);

				item.description.innerHTML = data.description;
				item.value.innerHTML = data.displayValue;
				item.node.classList.toggle('is-hidden', !data.visible);
			}
		});
	}
}
/*
class SummaryItem{ // Custom summary lines defined in WP
	constructor(data){
		this.id = data.id;
		this.type = data.type;
		this.value = data.value;
		this.isPlaceholder = data.is_placeholder;
		this.computedValue = null;
		this.html = new SummaryNode(customizer.summary.node.querySelector('.cmz-summary-option[data-id="' + this.id + '"]'));
	}

	getComputedValue(){
		// Skip if static
		if (this.type == 'static'){
			return this.value;
		}

		let value = this.value;
		let computedValue = 0;

		// Replace placeholders
		for (const key in customizer.summary.placeholders){
			value = value.replaceAll(key, customizer.summary.placeholders[key]);
		}

		// Stop if not all placeholders were resolved
		if (value.indexOf('{') !== -1 || value.indexOf('{') !== -1){
			return computedValue;
		}
		
		// Replace decimal operator
		value = value.replaceAll(',', '.');

		// Stop if not a valid operation (need regexp)
		//...

		// Compute
		eval('value = ' + value + ';');

		return value;
	}

	update(){
		// Get computed value
		this.computedValue = this.getComputedValue();
		
		// Format
		const displayValue = typeof this.computedValue === 'string' ? this.computedValue : this.computedValue.toPrice();
		
		// Insert
		this.html.insert('value', displayValue);
	}
}
*/

class SummarySpot{
	constructor(){
		// Editor
		this.node = document.querySelector('.cmz-summary-body .cmz-summary-group[data-id="spot"]');
		this.title = this.node.querySelector('.cmz-summary-group-title');
		this.value = this.node.querySelector('.cmz-summary-group-value');
		this.specs = this.node.querySelector('.cmz-summary-options tbody');
		this.template = this.node.querySelector('#cmz-template-summary-option');
		
		// Breakdown
		// this.bill = new SummaryNode(document.querySelector('.cmz-summary-breakdown .cmz-summary-option[data-id="spot"]'));

		// Edit button scroll
		this.node.querySelector('.cmz-summary-group-edit-anchor').addEventListener('click', e => {
			customizer.spot.scrollIntoView(e);
		})
	}

	update(){
		const chosen = customizer.spot.hasChosen() ? customizer.spot.chosen : false;
		const name = chosen ? chosen.getName() : '';
		const price = chosen ? chosen.price.toPrice() : '';

		// Update section header
		this.title.innerHTML = name;
		this.value.innerHTML = price;

		// Update queue notice
		// ...

		// Update specs
		this.specs.innerHTML = '';

		// Bill
		// this.bill.insert('subtitle', name);
		// this.bill.insert('value', price);
		// this.bill.node.classList.toggle('is-hidden', !chosen || price === '');

		if (!chosen){
			return;
		}

		chosen.specs.forEach(spec => {
			if (['name', 'price'].includes(spec.id)) return;
			this.addSpec(spec);
		});
	}

	addSpec(spec){
		const node = this.template.cloneNode(true).content;

		node.querySelector('.cmz-summary-option-title').innerHTML = spec.name;
		node.querySelector('.cmz-summary-option-value').innerHTML = spec.getDisplayValue();

		if (spec.icon){
			node.querySelector('.cmz-summary-option-name').classList.add('cmz-iconb-' + spec.icon);
		}

		this.specs.appendChild(node);
	}
}

class SummarySteps{
	constructor(id){
		this.id = id; // id (ideally, all section.id would be changed to id for harmonization)
		this.node = document.querySelector('.cmz-summary-group[data-id="' + this.id + '"]');
		this.items = [];
		/*
		if (this.id == 'spot'){
			this.title = this.node.querySelector('.cmz-summary-group-title');
			this.value = this.node.querySelector('.cmz-summary-group-value');
		}
		*/
	}

	add(item){
		this.items.push(item);
	}

	update(){
		let hasActiveItem = false;

		this.items.map(item => {
			item.update();

			if (item.visible){
				hasActiveItem = true;
			}
		});

		this.node.classList.toggle('has-active-items', hasActiveItem);
	}
}

class SummaryNode{
	constructor(node){
		// Convert to node if id passed
		if (node instanceof HTMLElement == false){
			node = customizer.summary.node.querySelector('.cmz-summary-option[data-id="' + node + '"]');
		}
			
		if (!node){
			console.warn('SummaryNode not created: node not found', node);
			this.node = null;
			return;
		}

		this.node = node;
		// this.id = node.getAttribute('data-id');
		// this.node = document.querySelector('.cmz-summary-body .cmz-summary-option[data-id="' + this.id + '"]');
		// this.subtitle = this.node.querySelector('.cmz-summary-option-subtitle');
		// this.value = this.node.querySelector('.cmz-summary-option-value');	
		// this.visible = false;

		this.nodes = {
			subtitle: this.node.querySelector('.cmz-summary-option-subtitle'),
			value: this.node.querySelector('.cmz-summary-option-value')
		};
	}

	insert(key, value){
		if (this.nodes.hasOwnProperty(key) && this.nodes[key]){
			this.nodes[key].innerHTML = value;
			return true;
		}
	}

	hide(toggle){
		this.node.classList.toggle('is-hidden', toggle);
	}
}

class SummaryNode_Step extends SummaryNode{
	constructor(step){
		super(document.querySelector('.cmz-summary-body .cmz-summary-option[data-id="' + step.id + '"]'));
		
		this.item = step;
		// this.bill = new SummaryNode(document.querySelector('.cmz-summary-breakdown .cmz-summary-option[data-id="' + step.id + '"]'));

		this.node.querySelector('.cmz-summary-option-edit-anchor').addEventListener('click', e => {
			this.item.scrollIntoView(e);
		})
	}

	update(){
		const value = this.item.getDisplayValue();
		const price = this.item.getTotal() ? this.item.getTotal().toPrice() : '';

		this.insert('subtitle', value);
		this.insert('value', price);

		this.visible = this.item.completed && this.item.fulfilled;
		// this.node.classList.toggle('is-hidden', !this.visible);
		this.hide(!this.visible);

		// Bill
		// this.bill.insert('subtitle', value);
		// this.bill.insert('value', price);
		// this.bill.node.classList.toggle('is-hidden', !this.visible || price === '');
	}
}

class SummaryNode_Boolean extends SummaryNode{
	constructor(option){
		super(document.querySelector('.cmz-summary-body .cmz-summary-option[data-id="' + option.id + '"]'));
		
		this.item = option;
		// this.bill = new SummaryNode(document.querySelector('.cmz-summary-breakdown .cmz-summary-option[data-id="' + option.id + '"]'));

		this.input = this.node.querySelector('.cmz-summary-option-edit-toggle input');

		this.input.addEventListener('change', () => {
			if ((this.input.checked && !this.item.input.checked) || (!this.input.checked && this.item.input.checked)){
				this.item.input.click();
			}
		});
	}

	update(){
		this.input.checked = this.item.input.checked;

		const value = this.item.input.checked ? _cmz('Sí') : _cmz('No');
		const price = !this.item.input.checked ? '<del>' + this.item.price.toPrice() + '</del>' : this.item.price.toPrice();

		this.insert('value', price);
		this.insert('subtitle', value);

		this.visible = this.item.fulfilled;
		// this.node.classList.toggle('is-hidden', !this.visible);
		this.hide(!this.visible);

		// Bill
		// this.bill.insert('subtitle', value);
		// this.bill.insert('value', price);
		// this.bill.node.classList.toggle('is-hidden', !this.visible || !this.input.checked || price === '');
	}
}

// Gallery
class Gallery{
	constructor(node){
		this.node = node;
		this.slider = this.node.querySelector('.cmz-gallery-items');
		this.items = [...this.node.querySelectorAll('.cmz-gallery-item')];
		this.groupIndexes = {}; // Map group index with first item index of this group
		this.current = 0;
		
		// Items
		this.items.forEach((item, index) => {
			const group = item.getAttribute('data-group');

			if (!this.groupIndexes.hasOwnProperty(group)){
				this.groupIndexes[group] = index;
			}

			item.addEventListener('click', () => {
				this.node.classList.add('is-enlarged');
				document.body.classList.add('noscroll');
			})
		})

		// Close
		this.node.querySelector('.cmz-gallery-close').addEventListener('click', () => {
			this.node.classList.remove('is-enlarged');
			document.body.classList.remove('noscroll');
		})

		if (this.items.length < 2) return;

		// Create nav
		this.nav = {
			backward: this.node.querySelector('.cmz-gallery-previous'),
			forward: this.node.querySelector('.cmz-gallery-next'),
			groups: [...this.node.querySelectorAll('.cmz-gallery-groups-nav-item > input')],
		};

		this.nav.backward.addEventListener('click', this.previous.bind(this));
		this.nav.forward.addEventListener('click', this.next.bind(this));

		if (this.nav.groups.length){
			this.nav.groups.forEach(input => {
				input.addEventListener('change', () => {
					// this.goToGroup(input.value);
					this.goTo(this.groupIndexes[input.value]);
				})
			});
		}

		// Create counter
		this.counter = this.node.querySelector('.cmz-gallery-counter');

		// Update on user scroll
		this.node.querySelector('.cmz-gallery-items').addEventListener('scroll', this.update.bind(this));

		// Set initial position
		// this.goTo(this.current);

		this.node.classList.add('ready');
	}

	update(){
		// @todo need to debounce function for opti
		// ...

		// const threshold = window.innerWidth * .5;
		const threshold = this.slider.scrollLeft + this.slider.offsetWidth * .5;

		this.items.forEach(item => {
			console.log({item, left: item.offsetLeft, right: item.offsetLeft + item.offsetWidth});
		})

		const index = this.items.findIndex(item => {
			// const b = item.getBoundingClientRect();
			// return b.left < threshold && b.right > threshold;
			return item.offsetLeft < threshold && item.offsetLeft + item.offsetWidth > threshold;
		});

		if (index == this.current){
			return;
		}

		// Update
		this.current = index;
		this.counter.textContent = this.current + 1;

		if (this.nav.groups.length){
			this.nav.groups[parseInt(this.items[index].getAttribute('data-group'))].checked = true;
		}
	}

	goTo(index){
		// Remove currents
		// this.items[this.current].parentNode.classList.remove('active');
		
		// Add new item current
		this.current = index;
		// this.items[index].parentNode.classList.add('active');

		// Update counter
		// this.counter.textContent = this.current + 1; // Updated with scroll

		// Scroll
		this.items[this.current].scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'});
	}

	previous(){
		let index = this.current - 1 < 0 ? this.items.length - 1 : this.current - 1;
		this.goTo(index);
	}

	next(){
		let index = this.current + 1 >= this.items.length ? 0 : this.current + 1;
		this.goTo(index);
	}
}

// Form
class NumberFormat{
	constructor(number, format){
		this.separators = {
			thousand: '',
			decimal: '',
			currency: '',
			literal: ''
		};

		// Set options
		this.options = {
			style: 'decimal',
			prefix: '',
			suffix: '',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		};

		const format_options = {
			percent: {
				style: 'percent',
				minimumFractionDigits: 1,
				maximumFractionDigits: 1,
			},
			currency: {
				style: 'currency',
				currency: customizer.settings.currency,
			},
			area: {
				style: 'unit',
				unit: customizer.settings.area,
				suffix: '²',
			}
		}[format];

		for (let k in format_options){
			this.options[k] = format_options[k];
		}

		this.formater = new Intl.NumberFormat(customizer.settings.locale, this.options);

		// Set separators
		this.formater.formatToParts(11111.11).forEach(part => {
			switch (part.type){
				case 'group':
					this.separators.thousand = part.value;
				break;

				case 'decimal':
					this.separators.decimal = part.value;
				break;

				case 'currency':
					this.separators.currency = part.value;
				break;

				case 'literal':
					this.separators.literal = part.value;
				break;
			}
		});

		// Unformat to work with numeric value
		if (typeof number === 'string'){
			number = !this.separators.thousand ? number : number.replaceAll(this.separators.thousand, '');
			number = !this.separators.currency ? number : number.replaceAll(this.separators.currency, '');
			number = !this.separators.literal ? number : number.replaceAll(this.separators.literal, '');
			number = !this.separators.decimal ? number : number.replaceAll(this.separators.decimal, '.');
		}

		this.number = parseFloat(number);
	}

	format(){
		return this.options.prefix + this.formater.format(this.number) + this.options.suffix;
	}

	unformat(){
		return this.number;
	}
}

class Form_Input{
	constructor(input){
		this.wrap = input.parentNode;
		this.input = input;
		this.type = input.type;
	}

	changed(){
		this.input.dispatchEvent(new Event('change'));
	}
}

class Form_Input_Number extends Form_Input{
	constructor(input){
		super(input);

		this.format = this.input.getAttribute('data-format');
		this.format = false; // Temporary shutdown

		this.value = parseFloat(this.input.value) || 0;
		this.step = parseFloat(this.input.getAttribute('step')) || 1;
		this.min = parseFloat(this.input.getAttribute('min')) || 0; // This remove support for negative numbers. Problematic?
		this.max = parseFloat(this.input.getAttribute('max')) || Infinity;
		
		this.enhancer = {
			timeout: null,
			interval: null
		};

		// Step up button
		this.enhancer.stepup = document.createElement('div');
		this.enhancer.stepup.classList.add('cmz-form-input-number-stepup');
		this.enhancer.stepup.addEventListener('mousedown', this.startStepUpSpree.bind(this));
		this.enhancer.stepup.addEventListener('mouseup', this.stopSpree.bind(this));
		this.enhancer.stepup.addEventListener('mouseleave', this.stopSpree.bind(this));
		
		// Step down button
		this.enhancer.stepdown = document.createElement('div');
		this.enhancer.stepdown.classList.add('cmz-form-input-number-stepdown');
		this.enhancer.stepdown.addEventListener('mousedown', this.startStepDownSpree.bind(this));
		this.enhancer.stepdown.addEventListener('mouseup', this.stopSpree.bind(this));
		this.enhancer.stepdown.addEventListener('mouseleave', this.stopSpree.bind(this));

		window.addEventListener('contextmenu', this.stopSpree.bind(this));

		this.wrap.appendChild(this.enhancer.stepdown);
		this.wrap.appendChild(this.enhancer.stepup);

		// Update min/max
		this.input.addEventListener('change', () => {
			this.updateView();
		});

		this.updateView();

		// Unit
		if (this.format){
			// Convert to input type text to allow formatting
			this.input.type = 'text';

			// Create view
			// this.enhancer.view = document.createElement('div');
			// this.enhancer.view.classList.add('cmz-form-input-number-view');

			// Bind with input value change
			this.input.addEventListener('change', this.formatValue.bind(this));

			// Add to wrap
			// this.wrap.insertBefore(this.enhancer.view, this.wrap.firstElementChild);
			
			this.formatValue();
		}

		this.wrap.classList.add('enhanced');
	}

	formatValue(){
		this.setValue(this.input.value);
	}

	setValue(value){
		// Todo: need to remove length difference between unformated and unformated to avoid caret to jump numebrs)
		// Todo: add event lisneter arrowUp arrowDown when focus to stepUp stepDown
		if (value == ''){
			return;
		}

		// Update min/max in case it has changed since last time
		this.min = parseFloat(this.input.getAttribute('min')) || 0; // This remove support for negative numbers. Problematic?
		this.max = parseFloat(this.input.getAttribute('max')) || Infinity;

		// Sanitize format
		value = parseFloat(value).sanitize();

		// Clamp
		value = Math.min(Math.max(value, this.min), this.max);

		// Backup selection 
		if (this.input.type == 'text'){
			var start = this.input.selectionStart;
			var end = this.input.selectionEnd;
		}

		// let oldValue = this.input.value;

		// Replace value
		if (this.format){
			let number = new NumberFormat(value, this.format);
			this.value = number.unformat();
			this.input.value = number.format();
		}
		else{
			this.value = value;
			this.input.value = value;
		}

		// Set min/max
		this.updateView();

		// Force selection
		if (this.input.type == 'text'){
			this.input.setSelectionRange(start, end);
		}
	}

	stepUp(){
		this.setValue(parseFloat(this.input.value) + this.step); // used to use this.value() but changed to parseFloat(this.input.value) for demo, conflict with unit formatting (quick fix for demo)
		this.input.dispatchEvent(new Event('input'));
		this.input.dispatchEvent(new Event('change'));
		// this.input.stepUp();
	}

	stepDown(){
		this.setValue(parseFloat(this.input.value) - this.step); // used to use this.value() but changed to parseFloat(this.input.value) for demo, conflict with unit formatting (quick fix for demo)
		this.input.dispatchEvent(new Event('input'));
		this.input.dispatchEvent(new Event('change'));
		// this.input.stepDown();
		// this.input.focus();  // not working
	}

	startStepUpSpree(){
		this.stepUp();

		this.enhancer.timeout = setTimeout(() => {
			this.enhancer.interval = setInterval(this.stepUp.bind(this), 50);
		}, 200);
	}

	startStepDownSpree(){
		this.stepDown();

		this.enhancer.timeout = setTimeout(() => {
			this.enhancer.interval = setInterval(this.stepDown.bind(this), 50);
		}, 200);
	}

	stopSpree(){
		clearTimeout(this.enhancer.timeout);
		clearInterval(this.enhancer.interval);
	}

	updateView(){
		this.wrap.classList.toggle('max-reached', this.input.value >= this.max);
		this.wrap.classList.toggle('min-reached', this.input.value <= this.min);
	}
}

// Forms and inputs
class InputBundle{
	constructor(inputs){
		this.inputs = inputs;

		this.inputs.forEach(input => {
			input.addEventListener('input', (e) => {
				// Prevent infinit loop (sibling updates sibling that updates sibling...)
				if (e.detail === 'updatedBySibling'){
					return;
				}

				this.updateSiblings(input);
			});
		});
	}

	updateSiblings(input){
		this.inputs.forEach(sibling => {
			if (sibling == input){
				return;
			}

			sibling.min = input.min;
			sibling.max = input.max;
			sibling.value = input.value;

			sibling.dispatchEvent(new CustomEvent('input', {detail: 'updatedBySibling'}))
		});

	}
}

class ScrollBlockerInput{
	constructor(input, condition){
		if (typeof condition != 'function'){
			condition = () => {
				return input.checked;
			};
		}

		input.addEventListener('input', () => {
			document.body.classList.toggle('noscroll', condition());
		});
	}
}

class Draggable{
	constructor(node){
		this.node = node;
		
		this.mouseDown = false;
		this.startX = 0;
		this.scrollLeft = 0;
		
		this.node.addEventListener('mousemove', this.move.bind(this), false);
		this.node.addEventListener('mousedown', this.startDragging.bind(this), false);
		this.node.addEventListener('mouseup', this.stopDragging.bind(this), false);
		this.node.addEventListener('mouseleave', this.stopDragging.bind(this), false);
	}

	startDragging(e){
		this.mouseDown = true;
		this.startX = e.pageX - this.node.offsetLeft;
		this.scrollLeft = this.node.scrollLeft;
	}

	stopDragging(e){
		this.mouseDown = false;
		this.node.classList.remove('is-dragged');
	}

	move(e){
		if (!this.mouseDown) return; // @opti use removeEventListener('move') insetad of always checking for mouseDOwn
		
		e.preventDefault();
	
		const shift = (e.pageX - this.node.offsetLeft) - this.startX;

		// Do not start drag until significant scroll (prevent missclick)
		if (Math.abs(shift) < 5){
			return;
		}

		this.node.classList.add('is-dragged');
		this.node.scrollLeft = this.scrollLeft - shift;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	// Bail early if no CMZ object (happens on customizer page when user not logged in)
	if (typeof CMZ === 'undefined'){
		console.warn('Customizer not initialized: No CMZ object not found');
		return;
	}

	// Set viewport height (mobile address bar fix)
	document.documentElement.style.setProperty('--cmz-viewport-height', (window.innerHeight - .1) + 'px'); // remove 0.1px to prevent desktop scrollbar to show up

	window.addEventListener('resize', () => {
		document.documentElement.style.setProperty('--cmz-viewport-height', (window.innerHeight - .1) + 'px');
	})

	window.requestAnimationFrame(() => { // Wait for form inputs to retrieve their value when previous button clicked on checkout page (bugfix for php fallback)
		customizer = new Customizer();

		document.querySelectorAll('.cmz-gallery').forEach(gallery => {
			new Gallery(gallery);
		})

		document.querySelectorAll('input[type="number"]').forEach(input => {
			new Form_Input_Number(input);
		});

		// Remove body scroll when popup/panel are opened
		// Large and small screen
		document.querySelectorAll('.cmz-storyline-input, #cmz-prices-input, .cmz-tooltip .cmz-popup-input, #cmz-user-input, #cmz-geo-input').forEach(input => {
			new ScrollBlockerInput(input);
		});

		// Small screen only (#cmz-checkout-cart-input not working: customizer.js not loaded on checkout page)
		document.querySelectorAll('#cmz-spot-filters-input, #cmz-checkout-cart-input').forEach(input => {
			new ScrollBlockerInput(input, () => {
				return input.checked && window.innerWidth < 1024;
			});
		});

		// Draggable elements
		document.querySelectorAll('.cmz-draggable').forEach(node => {
			new Draggable(node);
		});


	});
});